/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Vendor -------------------------------------------------------------------- */
   /* current-device -------------------------------------------------------------------- */
     /*!
      * current-device v0.10.1 - https://github.com/matthewhudson/current-device
      * MIT Licensed
      */
     !function(n,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.device=e():n.device=e()}(window,function(){return function(n){var e={};function o(t){if(e[t])return e[t].exports;var r=e[t]={i:t,l:!1,exports:{}};return n[t].call(r.exports,r,r.exports,o),r.l=!0,r.exports}return o.m=n,o.c=e,o.d=function(n,e,t){o.o(n,e)||Object.defineProperty(n,e,{enumerable:!0,get:t})},o.r=function(n){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(n,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(n,"__esModule",{value:!0})},o.t=function(n,e){if(1&e&&(n=o(n)),8&e)return n;if(4&e&&"object"==typeof n&&n&&n.__esModule)return n;var t=Object.create(null);if(o.r(t),Object.defineProperty(t,"default",{enumerable:!0,value:n}),2&e&&"string"!=typeof n)for(var r in n)o.d(t,r,function(e){return n[e]}.bind(null,r));return t},o.n=function(n){var e=n&&n.__esModule?function(){return n.default}:function(){return n};return o.d(e,"a",e),e},o.o=function(n,e){return Object.prototype.hasOwnProperty.call(n,e)},o.p="",o(o.s=0)}([function(n,e,o){n.exports=o(1)},function(n,e,o){"use strict";o.r(e);var t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(n){return typeof n}:function(n){return n&&"function"==typeof Symbol&&n.constructor===Symbol&&n!==Symbol.prototype?"symbol":typeof n},r=window.device,i={},a=[];window.device=i;var c=window.document.documentElement,d=window.navigator.userAgent.toLowerCase(),u=["googletv","viera","smarttv","internet.tv","netcast","nettv","appletv","boxee","kylo","roku","dlnadoc","pov_tv","hbbtv","ce-html"];function l(n,e){return-1!==n.indexOf(e)}function s(n){return l(d,n)}function f(n){return c.className.match(new RegExp(n,"i"))}function b(n){var e=null;f(n)||(e=c.className.replace(/^\s+|\s+$/g,""),c.className=e+" "+n)}function p(n){f(n)&&(c.className=c.className.replace(" "+n,""))}function w(){i.landscape()?(p("portrait"),b("landscape"),y("landscape")):(p("landscape"),b("portrait"),y("portrait")),v()}function y(n){for(var e=0;e<a.length;e++)a[e](n)}i.macos=function(){return s("mac")},i.ios=function(){return i.iphone()||i.ipod()||i.ipad()},i.iphone=function(){return!i.windows()&&s("iphone")},i.ipod=function(){return s("ipod")},i.ipad=function(){var n="MacIntel"===navigator.platform&&navigator.maxTouchPoints>1;return s("ipad")||n},i.android=function(){return!i.windows()&&s("android")},i.androidPhone=function(){return i.android()&&s("mobile")},i.androidTablet=function(){return i.android()&&!s("mobile")},i.blackberry=function(){return s("blackberry")||s("bb10")},i.blackberryPhone=function(){return i.blackberry()&&!s("tablet")},i.blackberryTablet=function(){return i.blackberry()&&s("tablet")},i.windows=function(){return s("windows")},i.windowsPhone=function(){return i.windows()&&s("phone")},i.windowsTablet=function(){return i.windows()&&s("touch")&&!i.windowsPhone()},i.fxos=function(){return(s("(mobile")||s("(tablet"))&&s(" rv:")},i.fxosPhone=function(){return i.fxos()&&s("mobile")},i.fxosTablet=function(){return i.fxos()&&s("tablet")},i.meego=function(){return s("meego")},i.cordova=function(){return window.cordova&&"file:"===location.protocol},i.nodeWebkit=function(){return"object"===t(window.process)},i.mobile=function(){return i.androidPhone()||i.iphone()||i.ipod()||i.windowsPhone()||i.blackberryPhone()||i.fxosPhone()||i.meego()},i.tablet=function(){return i.ipad()||i.androidTablet()||i.blackberryTablet()||i.windowsTablet()||i.fxosTablet()},i.desktop=function(){return!i.tablet()&&!i.mobile()},i.television=function(){for(var n=0;n<u.length;){if(s(u[n]))return!0;n++}return!1},i.portrait=function(){return screen.orientation&&Object.prototype.hasOwnProperty.call(window,"onorientationchange")?l(screen.orientation.type,"portrait"):i.ios()&&Object.prototype.hasOwnProperty.call(window,"orientation")?90!==Math.abs(window.orientation):window.innerHeight/window.innerWidth>1},i.landscape=function(){return screen.orientation&&Object.prototype.hasOwnProperty.call(window,"onorientationchange")?l(screen.orientation.type,"landscape"):i.ios()&&Object.prototype.hasOwnProperty.call(window,"orientation")?90===Math.abs(window.orientation):window.innerHeight/window.innerWidth<1},i.noConflict=function(){return window.device=r,this},i.ios()?i.ipad()?b("ios ipad tablet"):i.iphone()?b("ios iphone mobile"):i.ipod()&&b("ios ipod mobile"):i.macos()?b("macos desktop"):i.android()?i.androidTablet()?b("android tablet"):b("android mobile"):i.blackberry()?i.blackberryTablet()?b("blackberry tablet"):b("blackberry mobile"):i.windows()?i.windowsTablet()?b("windows tablet"):i.windowsPhone()?b("windows mobile"):b("windows desktop"):i.fxos()?i.fxosTablet()?b("fxos tablet"):b("fxos mobile"):i.meego()?b("meego mobile"):i.nodeWebkit()?b("node-webkit"):i.television()?b("television"):i.desktop()&&b("desktop"),i.cordova()&&b("cordova"),i.onChangeOrientation=function(n){"function"==typeof n&&a.push(n)};var m="resize";function h(n){for(var e=0;e<n.length;e++)if(i[n[e]]())return n[e];return"unknown"}function v(){i.orientation=h(["portrait","landscape"])}Object.prototype.hasOwnProperty.call(window,"onorientationchange")&&(m="orientationchange"),window.addEventListener?window.addEventListener(m,w,!1):window.attachEvent?window.attachEvent(m,w):window[m]=w,w(),i.type=h(["mobile","tablet","desktop"]),i.os=h(["ios","iphone","ipad","ipod","android","blackberry","macos","windows","fxos","meego","television"]),v(),e.default=i}]).default});
   /* current-device -------------------------------------------------------------------- */
   if(window.jQuery) {
   /* magnific popup -------------------------------------------------------------------- */
   	  /*! Magnific Popup - v1.1.0 - 2016-02-20
	   * http://dimsemenov.com/plugins/magnific-popup/
	   * Copyright (c) 2016 Dmitry Semenov; */
	   !function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a("object"==typeof exports?require("jquery"):window.jQuery||window.Zepto)}(function(a){var b,c,d,e,f,g,h="Close",i="BeforeClose",j="AfterClose",k="BeforeAppend",l="MarkupParse",m="Open",n="Change",o="mfp",p="."+o,q="mfp-ready",r="mfp-removing",s="mfp-prevent-close",t=function(){},u=!!window.jQuery,v=a(window),w=function(a,c){b.ev.on(o+a+p,c)},x=function(b,c,d,e){var f=document.createElement("div");return f.className="mfp-"+b,d&&(f.innerHTML=d),e?c&&c.appendChild(f):(f=a(f),c&&f.appendTo(c)),f},y=function(c,d){b.ev.triggerHandler(o+c,d),b.st.callbacks&&(c=c.charAt(0).toLowerCase()+c.slice(1),b.st.callbacks[c]&&b.st.callbacks[c].apply(b,a.isArray(d)?d:[d]))},z=function(c){return c===g&&b.currTemplate.closeBtn||(b.currTemplate.closeBtn=a(b.st.closeMarkup.replace("%title%",b.st.tClose)),g=c),b.currTemplate.closeBtn},A=function(){a.magnificPopup.instance||(b=new t,b.init(),a.magnificPopup.instance=b)},B=function(){var a=document.createElement("p").style,b=["ms","O","Moz","Webkit"];if(void 0!==a.transition)return!0;for(;b.length;)if(b.pop()+"Transition"in a)return!0;return!1};t.prototype={constructor:t,init:function(){var c=navigator.appVersion;b.isLowIE=b.isIE8=document.all&&!document.addEventListener,b.isAndroid=/android/gi.test(c),b.isIOS=/iphone|ipad|ipod/gi.test(c),b.supportsTransition=B(),b.probablyMobile=b.isAndroid||b.isIOS||/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),d=a(document),b.popupsCache={}},open:function(c){var e;if(c.isObj===!1){b.items=c.items.toArray(),b.index=0;var g,h=c.items;for(e=0;e<h.length;e++)if(g=h[e],g.parsed&&(g=g.el[0]),g===c.el[0]){b.index=e;break}}else b.items=a.isArray(c.items)?c.items:[c.items],b.index=c.index||0;if(b.isOpen)return void b.updateItemHTML();b.types=[],f="",c.mainEl&&c.mainEl.length?b.ev=c.mainEl.eq(0):b.ev=d,c.key?(b.popupsCache[c.key]||(b.popupsCache[c.key]={}),b.currTemplate=b.popupsCache[c.key]):b.currTemplate={},b.st=a.extend(!0,{},a.magnificPopup.defaults,c),b.fixedContentPos="auto"===b.st.fixedContentPos?!b.probablyMobile:b.st.fixedContentPos,b.st.modal&&(b.st.closeOnContentClick=!1,b.st.closeOnBgClick=!1,b.st.showCloseBtn=!1,b.st.enableEscapeKey=!1),b.bgOverlay||(b.bgOverlay=x("bg").on("click"+p,function(){b.close()}),b.wrap=x("wrap").attr("tabindex",-1).on("click"+p,function(a){b._checkIfClose(a.target)&&b.close()}),b.container=x("container",b.wrap)),b.contentContainer=x("content"),b.st.preloader&&(b.preloader=x("preloader",b.container,b.st.tLoading));var i=a.magnificPopup.modules;for(e=0;e<i.length;e++){var j=i[e];j=j.charAt(0).toUpperCase()+j.slice(1),b["init"+j].call(b)}y("BeforeOpen"),b.st.showCloseBtn&&(b.st.closeBtnInside?(w(l,function(a,b,c,d){c.close_replaceWith=z(d.type)}),f+=" mfp-close-btn-in"):b.wrap.append(z())),b.st.alignTop&&(f+=" mfp-align-top"),b.fixedContentPos?b.wrap.css({overflow:b.st.overflowY,overflowX:"hidden",overflowY:b.st.overflowY}):b.wrap.css({top:v.scrollTop(),position:"absolute"}),(b.st.fixedBgPos===!1||"auto"===b.st.fixedBgPos&&!b.fixedContentPos)&&b.bgOverlay.css({height:d.height(),position:"absolute"}),b.st.enableEscapeKey&&d.on("keyup"+p,function(a){27===a.keyCode&&b.close()}),v.on("resize"+p,function(){b.updateSize()}),b.st.closeOnContentClick||(f+=" mfp-auto-cursor"),f&&b.wrap.addClass(f);var k=b.wH=v.height(),n={};if(b.fixedContentPos&&b._hasScrollBar(k)){var o=b._getScrollbarSize();o&&(n.marginRight=o)}b.fixedContentPos&&(b.isIE7?a("body, html").css("overflow","hidden"):n.overflow="hidden");var r=b.st.mainClass;return b.isIE7&&(r+=" mfp-ie7"),r&&b._addClassToMFP(r),b.updateItemHTML(),y("BuildControls"),a("html").css(n),b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo||a(document.body)),b._lastFocusedEl=document.activeElement,setTimeout(function(){b.content?(b._addClassToMFP(q),b._setFocus()):b.bgOverlay.addClass(q),d.on("focusin"+p,b._onFocusIn)},16),b.isOpen=!0,b.updateSize(k),y(m),c},close:function(){b.isOpen&&(y(i),b.isOpen=!1,b.st.removalDelay&&!b.isLowIE&&b.supportsTransition?(b._addClassToMFP(r),setTimeout(function(){b._close()},b.st.removalDelay)):b._close())},_close:function(){y(h);var c=r+" "+q+" ";if(b.bgOverlay.detach(),b.wrap.detach(),b.container.empty(),b.st.mainClass&&(c+=b.st.mainClass+" "),b._removeClassFromMFP(c),b.fixedContentPos){var e={marginRight:""};b.isIE7?a("body, html").css("overflow",""):e.overflow="",a("html").css(e)}d.off("keyup"+p+" focusin"+p),b.ev.off(p),b.wrap.attr("class","mfp-wrap").removeAttr("style"),b.bgOverlay.attr("class","mfp-bg"),b.container.attr("class","mfp-container"),!b.st.showCloseBtn||b.st.closeBtnInside&&b.currTemplate[b.currItem.type]!==!0||b.currTemplate.closeBtn&&b.currTemplate.closeBtn.detach(),b.st.autoFocusLast&&b._lastFocusedEl&&a(b._lastFocusedEl).focus(),b.currItem=null,b.content=null,b.currTemplate=null,b.prevHeight=0,y(j)},updateSize:function(a){if(b.isIOS){var c=document.documentElement.clientWidth/window.innerWidth,d=window.innerHeight*c;b.wrap.css("height",d),b.wH=d}else b.wH=a||v.height();b.fixedContentPos||b.wrap.css("height",b.wH),y("Resize")},updateItemHTML:function(){var c=b.items[b.index];b.contentContainer.detach(),b.content&&b.content.detach(),c.parsed||(c=b.parseEl(b.index));var d=c.type;if(y("BeforeChange",[b.currItem?b.currItem.type:"",d]),b.currItem=c,!b.currTemplate[d]){var f=b.st[d]?b.st[d].markup:!1;y("FirstMarkupParse",f),f?b.currTemplate[d]=a(f):b.currTemplate[d]=!0}e&&e!==c.type&&b.container.removeClass("mfp-"+e+"-holder");var g=b["get"+d.charAt(0).toUpperCase()+d.slice(1)](c,b.currTemplate[d]);b.appendContent(g,d),c.preloaded=!0,y(n,c),e=c.type,b.container.prepend(b.contentContainer),y("AfterChange")},appendContent:function(a,c){b.content=a,a?b.st.showCloseBtn&&b.st.closeBtnInside&&b.currTemplate[c]===!0?b.content.find(".mfp-close").length||b.content.append(z()):b.content=a:b.content="",y(k),b.container.addClass("mfp-"+c+"-holder"),b.contentContainer.append(b.content)},parseEl:function(c){var d,e=b.items[c];if(e.tagName?e={el:a(e)}:(d=e.type,e={data:e,src:e.src}),e.el){for(var f=b.types,g=0;g<f.length;g++)if(e.el.hasClass("mfp-"+f[g])){d=f[g];break}e.src=e.el.attr("data-mfp-src"),e.src||(e.src=e.el.attr("href"))}return e.type=d||b.st.type||"inline",e.index=c,e.parsed=!0,b.items[c]=e,y("ElementParse",e),b.items[c]},addGroup:function(a,c){var d=function(d){d.mfpEl=this,b._openClick(d,a,c)};c||(c={});var e="click.magnificPopup";c.mainEl=a,c.items?(c.isObj=!0,a.off(e).on(e,d)):(c.isObj=!1,c.delegate?a.off(e).on(e,c.delegate,d):(c.items=a,a.off(e).on(e,d)))},_openClick:function(c,d,e){var f=void 0!==e.midClick?e.midClick:a.magnificPopup.defaults.midClick;if(f||!(2===c.which||c.ctrlKey||c.metaKey||c.altKey||c.shiftKey)){var g=void 0!==e.disableOn?e.disableOn:a.magnificPopup.defaults.disableOn;if(g)if(a.isFunction(g)){if(!g.call(b))return!0}else if(v.width()<g)return!0;c.type&&(c.preventDefault(),b.isOpen&&c.stopPropagation()),e.el=a(c.mfpEl),e.delegate&&(e.items=d.find(e.delegate)),b.open(e)}},updateStatus:function(a,d){if(b.preloader){c!==a&&b.container.removeClass("mfp-s-"+c),d||"loading"!==a||(d=b.st.tLoading);var e={status:a,text:d};y("UpdateStatus",e),a=e.status,d=e.text,b.preloader.html(d),b.preloader.find("a").on("click",function(a){a.stopImmediatePropagation()}),b.container.addClass("mfp-s-"+a),c=a}},_checkIfClose:function(c){if(!a(c).hasClass(s)){var d=b.st.closeOnContentClick,e=b.st.closeOnBgClick;if(d&&e)return!0;if(!b.content||a(c).hasClass("mfp-close")||b.preloader&&c===b.preloader[0])return!0;if(c===b.content[0]||a.contains(b.content[0],c)){if(d)return!0}else if(e&&a.contains(document,c))return!0;return!1}},_addClassToMFP:function(a){b.bgOverlay.addClass(a),b.wrap.addClass(a)},_removeClassFromMFP:function(a){this.bgOverlay.removeClass(a),b.wrap.removeClass(a)},_hasScrollBar:function(a){return(b.isIE7?d.height():document.body.scrollHeight)>(a||v.height())},_setFocus:function(){(b.st.focus?b.content.find(b.st.focus).eq(0):b.wrap).focus()},_onFocusIn:function(c){return c.target===b.wrap[0]||a.contains(b.wrap[0],c.target)?void 0:(b._setFocus(),!1)},_parseMarkup:function(b,c,d){var e;d.data&&(c=a.extend(d.data,c)),y(l,[b,c,d]),a.each(c,function(c,d){if(void 0===d||d===!1)return!0;if(e=c.split("_"),e.length>1){var f=b.find(p+"-"+e[0]);if(f.length>0){var g=e[1];"replaceWith"===g?f[0]!==d[0]&&f.replaceWith(d):"img"===g?f.is("img")?f.attr("src",d):f.replaceWith(a("<img>").attr("src",d).attr("class",f.attr("class"))):f.attr(e[1],d)}}else b.find(p+"-"+c).html(d)})},_getScrollbarSize:function(){if(void 0===b.scrollbarSize){var a=document.createElement("div");a.style.cssText="width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",document.body.appendChild(a),b.scrollbarSize=a.offsetWidth-a.clientWidth,document.body.removeChild(a)}return b.scrollbarSize}},a.magnificPopup={instance:null,proto:t.prototype,modules:[],open:function(b,c){return A(),b=b?a.extend(!0,{},b):{},b.isObj=!0,b.index=c||0,this.instance.open(b)},close:function(){return a.magnificPopup.instance&&a.magnificPopup.instance.close()},registerModule:function(b,c){c.options&&(a.magnificPopup.defaults[b]=c.options),a.extend(this.proto,c.proto),this.modules.push(b)},defaults:{disableOn:0,key:null,midClick:!1,mainClass:"",preloader:!0,focus:"",closeOnContentClick:!1,closeOnBgClick:!0,closeBtnInside:!0,showCloseBtn:!0,enableEscapeKey:!0,modal:!1,alignTop:!1,removalDelay:0,prependTo:null,fixedContentPos:"auto",fixedBgPos:"auto",overflowY:"auto",closeMarkup:'<button title="%title%" type="button" class="mfp-close">&#215;</button>',tClose:"Close (Esc)",tLoading:"Loading...",autoFocusLast:!0}},a.fn.magnificPopup=function(c){A();var d=a(this);if("string"==typeof c)if("open"===c){var e,f=u?d.data("magnificPopup"):d[0].magnificPopup,g=parseInt(arguments[1],10)||0;f.items?e=f.items[g]:(e=d,f.delegate&&(e=e.find(f.delegate)),e=e.eq(g)),b._openClick({mfpEl:e},d,f)}else b.isOpen&&b[c].apply(b,Array.prototype.slice.call(arguments,1));else c=a.extend(!0,{},c),u?d.data("magnificPopup",c):d[0].magnificPopup=c,b.addGroup(d,c);return d};var C,D,E,F="inline",G=function(){E&&(D.after(E.addClass(C)).detach(),E=null)};a.magnificPopup.registerModule(F,{options:{hiddenClass:"hide",markup:"",tNotFound:"Content not found"},proto:{initInline:function(){b.types.push(F),w(h+"."+F,function(){G()})},getInline:function(c,d){if(G(),c.src){var e=b.st.inline,f=a(c.src);if(f.length){var g=f[0].parentNode;g&&g.tagName&&(D||(C=e.hiddenClass,D=x(C),C="mfp-"+C),E=f.after(D).detach().removeClass(C)),b.updateStatus("ready")}else b.updateStatus("error",e.tNotFound),f=a("<div>");return c.inlineElement=f,f}return b.updateStatus("ready"),b._parseMarkup(d,{},c),d}}});var H,I="ajax",J=function(){H&&a(document.body).removeClass(H)},K=function(){J(),b.req&&b.req.abort()};a.magnificPopup.registerModule(I,{options:{settings:null,cursor:"mfp-ajax-cur",tError:'<a href="%url%">The content</a> could not be loaded.'},proto:{initAjax:function(){b.types.push(I),H=b.st.ajax.cursor,w(h+"."+I,K),w("BeforeChange."+I,K)},getAjax:function(c){H&&a(document.body).addClass(H),b.updateStatus("loading");var d=a.extend({url:c.src,success:function(d,e,f){var g={data:d,xhr:f};y("ParseAjax",g),b.appendContent(a(g.data),I),c.finished=!0,J(),b._setFocus(),setTimeout(function(){b.wrap.addClass(q)},16),b.updateStatus("ready"),y("AjaxContentAdded")},error:function(){J(),c.finished=c.loadError=!0,b.updateStatus("error",b.st.ajax.tError.replace("%url%",c.src))}},b.st.ajax.settings);return b.req=a.ajax(d),""}}});var L,M=function(c){if(c.data&&void 0!==c.data.title)return c.data.title;var d=b.st.image.titleSrc;if(d){if(a.isFunction(d))return d.call(b,c);if(c.el)return c.el.attr(d)||""}return""};a.magnificPopup.registerModule("image",{options:{markup:'<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',cursor:"mfp-zoom-out-cur",titleSrc:"title",verticalFit:!0,tError:'<a href="%url%">The image</a> could not be loaded.'},proto:{initImage:function(){var c=b.st.image,d=".image";b.types.push("image"),w(m+d,function(){"image"===b.currItem.type&&c.cursor&&a(document.body).addClass(c.cursor)}),w(h+d,function(){c.cursor&&a(document.body).removeClass(c.cursor),v.off("resize"+p)}),w("Resize"+d,b.resizeImage),b.isLowIE&&w("AfterChange",b.resizeImage)},resizeImage:function(){var a=b.currItem;if(a&&a.img&&b.st.image.verticalFit){var c=0;b.isLowIE&&(c=parseInt(a.img.css("padding-top"),10)+parseInt(a.img.css("padding-bottom"),10)),a.img.css("max-height",b.wH-c)}},_onImageHasSize:function(a){a.img&&(a.hasSize=!0,L&&clearInterval(L),a.isCheckingImgSize=!1,y("ImageHasSize",a),a.imgHidden&&(b.content&&b.content.removeClass("mfp-loading"),a.imgHidden=!1))},findImageSize:function(a){var c=0,d=a.img[0],e=function(f){L&&clearInterval(L),L=setInterval(function(){return d.naturalWidth>0?void b._onImageHasSize(a):(c>200&&clearInterval(L),c++,void(3===c?e(10):40===c?e(50):100===c&&e(500)))},f)};e(1)},getImage:function(c,d){var e=0,f=function(){c&&(c.img[0].complete?(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("ready")),c.hasSize=!0,c.loaded=!0,y("ImageLoadComplete")):(e++,200>e?setTimeout(f,100):g()))},g=function(){c&&(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("error",h.tError.replace("%url%",c.src))),c.hasSize=!0,c.loaded=!0,c.loadError=!0)},h=b.st.image,i=d.find(".mfp-img");if(i.length){var j=document.createElement("img");j.className="mfp-img",c.el&&c.el.find("img").length&&(j.alt=c.el.find("img").attr("alt")),c.img=a(j).on("load.mfploader",f).on("error.mfploader",g),j.src=c.src,i.is("img")&&(c.img=c.img.clone()),j=c.img[0],j.naturalWidth>0?c.hasSize=!0:j.width||(c.hasSize=!1)}return b._parseMarkup(d,{title:M(c),img_replaceWith:c.img},c),b.resizeImage(),c.hasSize?(L&&clearInterval(L),c.loadError?(d.addClass("mfp-loading"),b.updateStatus("error",h.tError.replace("%url%",c.src))):(d.removeClass("mfp-loading"),b.updateStatus("ready")),d):(b.updateStatus("loading"),c.loading=!0,c.hasSize||(c.imgHidden=!0,d.addClass("mfp-loading"),b.findImageSize(c)),d)}}});var N,O=function(){return void 0===N&&(N=void 0!==document.createElement("p").style.MozTransform),N};a.magnificPopup.registerModule("zoom",{options:{enabled:!1,easing:"ease-in-out",duration:300,opener:function(a){return a.is("img")?a:a.find("img")}},proto:{initZoom:function(){var a,c=b.st.zoom,d=".zoom";if(c.enabled&&b.supportsTransition){var e,f,g=c.duration,j=function(a){var b=a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),d="all "+c.duration/1e3+"s "+c.easing,e={position:"fixed",zIndex:9999,left:0,top:0,"-webkit-backface-visibility":"hidden"},f="transition";return e["-webkit-"+f]=e["-moz-"+f]=e["-o-"+f]=e[f]=d,b.css(e),b},k=function(){b.content.css("visibility","visible")};w("BuildControls"+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.content.css("visibility","hidden"),a=b._getItemToZoom(),!a)return void k();f=j(a),f.css(b._getOffset()),b.wrap.append(f),e=setTimeout(function(){f.css(b._getOffset(!0)),e=setTimeout(function(){k(),setTimeout(function(){f.remove(),a=f=null,y("ZoomAnimationEnded")},16)},g)},16)}}),w(i+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.st.removalDelay=g,!a){if(a=b._getItemToZoom(),!a)return;f=j(a)}f.css(b._getOffset(!0)),b.wrap.append(f),b.content.css("visibility","hidden"),setTimeout(function(){f.css(b._getOffset())},16)}}),w(h+d,function(){b._allowZoom()&&(k(),f&&f.remove(),a=null)})}},_allowZoom:function(){return"image"===b.currItem.type},_getItemToZoom:function(){return b.currItem.hasSize?b.currItem.img:!1},_getOffset:function(c){var d;d=c?b.currItem.img:b.st.zoom.opener(b.currItem.el||b.currItem);var e=d.offset(),f=parseInt(d.css("padding-top"),10),g=parseInt(d.css("padding-bottom"),10);e.top-=a(window).scrollTop()-f;var h={width:d.width(),height:(u?d.innerHeight():d[0].offsetHeight)-g-f};return O()?h["-moz-transform"]=h.transform="translate("+e.left+"px,"+e.top+"px)":(h.left=e.left,h.top=e.top),h}}});var P="iframe",Q="//about:blank",R=function(a){if(b.currTemplate[P]){var c=b.currTemplate[P].find("iframe");c.length&&(a||(c[0].src=Q),b.isIE8&&c.css("display",a?"block":"none"))}};a.magnificPopup.registerModule(P,{options:{markup:'<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',srcAction:"iframe_src",patterns:{youtube:{index:"youtube.com",id:"v=",src:"//www.youtube.com/embed/%id%?autoplay=1"},vimeo:{index:"vimeo.com/",id:"/",src:"//player.vimeo.com/video/%id%?autoplay=1"},gmaps:{index:"//maps.google.",src:"%id%&output=embed"}}},proto:{initIframe:function(){b.types.push(P),w("BeforeChange",function(a,b,c){b!==c&&(b===P?R():c===P&&R(!0))}),w(h+"."+P,function(){R()})},getIframe:function(c,d){var e=c.src,f=b.st.iframe;a.each(f.patterns,function(){return e.indexOf(this.index)>-1?(this.id&&(e="string"==typeof this.id?e.substr(e.lastIndexOf(this.id)+this.id.length,e.length):this.id.call(this,e)),e=this.src.replace("%id%",e),!1):void 0});var g={};return f.srcAction&&(g[f.srcAction]=e),b._parseMarkup(d,g,c),b.updateStatus("ready"),d}}});var S=function(a){var c=b.items.length;return a>c-1?a-c:0>a?c+a:a},T=function(a,b,c){return a.replace(/%curr%/gi,b+1).replace(/%total%/gi,c)};a.magnificPopup.registerModule("gallery",{options:{enabled:!1,arrowMarkup:'<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',preload:[0,2],navigateByImgClick:!0,arrows:!0,tPrev:"Previous (Left arrow key)",tNext:"Next (Right arrow key)",tCounter:"%curr% of %total%"},proto:{initGallery:function(){var c=b.st.gallery,e=".mfp-gallery";return b.direction=!0,c&&c.enabled?(f+=" mfp-gallery",w(m+e,function(){c.navigateByImgClick&&b.wrap.on("click"+e,".mfp-img",function(){return b.items.length>1?(b.next(),!1):void 0}),d.on("keydown"+e,function(a){37===a.keyCode?b.prev():39===a.keyCode&&b.next()})}),w("UpdateStatus"+e,function(a,c){c.text&&(c.text=T(c.text,b.currItem.index,b.items.length))}),w(l+e,function(a,d,e,f){var g=b.items.length;e.counter=g>1?T(c.tCounter,f.index,g):""}),w("BuildControls"+e,function(){if(b.items.length>1&&c.arrows&&!b.arrowLeft){var d=c.arrowMarkup,e=b.arrowLeft=a(d.replace(/%title%/gi,c.tPrev).replace(/%dir%/gi,"left")).addClass(s),f=b.arrowRight=a(d.replace(/%title%/gi,c.tNext).replace(/%dir%/gi,"right")).addClass(s);e.click(function(){b.prev()}),f.click(function(){b.next()}),b.container.append(e.add(f))}}),w(n+e,function(){b._preloadTimeout&&clearTimeout(b._preloadTimeout),b._preloadTimeout=setTimeout(function(){b.preloadNearbyImages(),b._preloadTimeout=null},16)}),void w(h+e,function(){d.off(e),b.wrap.off("click"+e),b.arrowRight=b.arrowLeft=null})):!1},next:function(){b.direction=!0,b.index=S(b.index+1),b.updateItemHTML()},prev:function(){b.direction=!1,b.index=S(b.index-1),b.updateItemHTML()},goTo:function(a){b.direction=a>=b.index,b.index=a,b.updateItemHTML()},preloadNearbyImages:function(){var a,c=b.st.gallery.preload,d=Math.min(c[0],b.items.length),e=Math.min(c[1],b.items.length);for(a=1;a<=(b.direction?e:d);a++)b._preloadItem(b.index+a);for(a=1;a<=(b.direction?d:e);a++)b._preloadItem(b.index-a)},_preloadItem:function(c){if(c=S(c),!b.items[c].preloaded){var d=b.items[c];d.parsed||(d=b.parseEl(c)),y("LazyLoad",d),"image"===d.type&&(d.img=a('<img class="mfp-img" />').on("load.mfploader",function(){d.hasSize=!0}).on("error.mfploader",function(){d.hasSize=!0,d.loadError=!0,y("LazyLoadError",d)}).attr("src",d.src)),d.preloaded=!0}}}});var U="retina";a.magnificPopup.registerModule(U,{options:{replaceSrc:function(a){return a.src.replace(/\.\w+$/,function(a){return"@2x"+a})},ratio:1},proto:{initRetina:function(){if(window.devicePixelRatio>1){var a=b.st.retina,c=a.ratio;c=isNaN(c)?c():c,c>1&&(w("ImageHasSize."+U,function(a,b){b.img.css({"max-width":b.img[0].naturalWidth/c,width:"100%"})}),w("ElementParse."+U,function(b,d){d.src=a.replaceSrc(d,c)}))}}}}),A()});
   /* magnific popup -------------------------------------------------------------------- */
   }
/* Vendor -------------------------------------------------------------------- */

/* Utils -------------------------------------------------------------------- */
  /* Trigger Click */
    function _cSc(el) {
      if(!el) return;
        var evt = new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window
          }),
          canceled = !el.dispatchEvent(evt);
    }
  /* Trigger Click */

  /* Fade Functions */
     function fadeOut(el) {
        el.style.opacity = 1;
        (function fade() {
            if ((el.style.opacity -= .1) < 0) {
                el.style.display = "none";
            } else {
                requestAnimationFrame(fade);
            }
        })();
      };

      function fadeIn(el,display) {
        el.style.opacity = 0;
        el.style.display = display || "block";
        (function fade() {
            var val = parseFloat(el.style.opacity);
            if (!((val += .1) > 1)) {
                el.style.opacity = val;
                requestAnimationFrame(fade);
            }
        })();
      };
  /* Fade Functions */
/* Utils -------------------------------------------------------------------- */

/* Menu -------------------------------------------------------------------- */
	var pageHeader,
	    menuWrapper,
	    level1Links,
	    listWrapper2,
	    listWrapper3,
	    imgWrapper,
	    subMenuWrapper2,
	    subMenuWrapper3,
	    backOneLevelBtns,
	    closeX,
	    menuBackdrop,
      pageBackdrop,
	    isVisibleClass,
	    isActiveClass,
	    // menuDesktopScrollbar,
	    desktopMobileEvents = false,
	    isTouchDevice = false,
	    mobileMenuCloseTimer = null,
	    mobileMenuCloseToken = 0;

	/* Utility Functions */
	  function detectTouchDevice() {
	    if(matchMedia('(hover: none), (pointer: coarse)').matches){
	      document.documentElement.classList.add('touch');
	      isTouchDevice = true;
	      return;
	    }
	    document.documentElement.classList.add('no-touch');
	  }
	/* Utility Functions */

	/* Listener Functions */
	  function keyUpHandler(event) {
	    if(event.which !== 27) return;
	    if(window.innerWidth <= 1024 || document.documentElement.classList.contains('tablet')) {
	      return;
	    }
	    closeDesktopMenu();
	  }

	  function customResizeHandler(event) {
	    mainMenuResponsiveEvents();
	  }

	  function customOrientationchangeHandler(event) {
	    mainMenuResponsiveEvents();
	  }

	  function mainMenuResponsiveEvents() {
	    // Close everything
	    if(menuBackdrop) menuBackdrop.classList.remove(isActiveClass);
      if(pageBackdrop) pageBackdrop.classList.remove(isVisibleClass);
	    if(menuWrapper) {
	      menuWrapper.classList.remove(isVisibleClass);
	      menuWrapper.classList.remove('mobile-is-closing');
	      menuWrapper.dataset.open = "0";
	      if(listWrapper2 && listWrapper2.classList.contains(isActiveClass)) listWrapper2.classList.remove(isActiveClass);
	      if(listWrapper2) listWrapper2.classList.remove(isVisibleClass);
	      if(listWrapper3) listWrapper3.classList.remove(isVisibleClass);
	      if(subMenuWrapper2) subMenuWrapper2.innerHTML = "";
	      if(subMenuWrapper3) subMenuWrapper3.innerHTML = "";
	    }
      document.documentElement.classList.remove('no-scroll','menu-open');
	    clearMobileMenuCloseScheduled();
	    mobileMenuCloseToken++;

	    // Clear Classes link LVL 0 (mobile)
	    if(level1Links) {
	      for(const level1Link of level1Links) {
	        level1Link.classList.remove(isActiveClass);
	      }
	    }

	    if(window.innerWidth <= 1024 || document.documentElement.classList.contains('tablet')) {
	      if(desktopMobileEvents) {
	        removeMainMenuDesktopEvents();
	        addMainMenuMobileEvents();
	        desktopMobileEvents = false;
	        if(window.Scrollbar && window.Scrollbar.getAll().length) {
	          window.Scrollbar.getAll().forEach(scrollbar => {
	            scrollbar.destroy();
	          });
	        }
	      } else if(!desktopMobileEvents) {
	        removeMainMenuDesktopEvents();
	        addMainMenuMobileEvents();
	      }
	      return;
	    }
	    if(window.innerWidth > 1024 && !document.documentElement.classList.contains('tablet') && !desktopMobileEvents) {
	      removeMainMenuMobileEvents();
	      addMainMenuDesktopEvents();
	      desktopMobileEvents = true;
	    }
	  }

	  function addMainMenuMobileEvents() {
	    /* MOBILE - CLICK */
	      /* Toggle Menu */
	      // debugger;
	        pageHeader.querySelector(".toggle-menu").addEventListener("click", toggleMobileMenu);
	      /* Toggle Menu */
	      // LEVEL 0 - FIST LEVEL ---- MOBILE
	      for(const level1Link of level1Links) {
	        level1Link.addEventListener("click", openMobileStLevel);
	      }

	      // LEVEL 1 - FIRST CHILD CATEGORIES ---- MOBILE
	      listWrapper2.addEventListener("click", openMobileNdLevel);

	      // BACK ---- MOBILE
	      for(const backOneLevelBtn of backOneLevelBtns) {
	        backOneLevelBtn.addEventListener("click", backOneLevel);
	      }
	    /* MOBILE - CLICK */
	  }

	  function removeMainMenuMobileEvents() {
	    /* MOBILE - CLICK */
	      const toggleBtn = pageHeader.querySelector(".toggle-menu");
	      if(toggleBtn) toggleBtn.removeEventListener("click", toggleMobileMenu);
	      for(const level1Link of level1Links) {
	        level1Link.removeEventListener("click", openMobileStLevel);
	      }
	      if(listWrapper2) listWrapper2.removeEventListener("click", openMobileNdLevel);
	      for(const backOneLevelBtn of backOneLevelBtns) {
	        backOneLevelBtn.removeEventListener("click", backOneLevel);
	      }
	    /* MOBILE - CLICK */
	  }

	  function addMainMenuDesktopEvents() {
	    /* Desktop mega menu is handled by assets/mega-nav.js (standalone). */
	  }

	  function removeMainMenuDesktopEvents() {
	    /* Desktop mega menu is handled by assets/mega-nav.js (standalone). */
	  }

	  // function openDesktopStLevelClearNdLevel(event) {
	  // 	if(!document.querySelector('.list-wrapper.is-visible') && ) return;
	  // 	event.preventDefault();
	  // 	debugger;
	  // }

	  function openDesktopNdLevel(event) {
	    // console.log("SECOND LVL");
	    if(!event.isTrusted || menuWrapper.classList.contains('is-closing')) return;
	    const target = event.target,
	      isLinkEl = target.tagName.toLowerCase() === "a";

	    // console.log(target);

	    if(isLinkEl) {
	      target.classList.remove('half-opacity');
	      target.classList.add('full-opacity');

	      // Set opacity to all link in the other list
	      if(target.closest('.level-2').children.length > 1) {
	        const el = target.parentElement.parentElement.parentElement;
	        if(el.nextElementSibling) {
	          for (const sibling of el.nextElementSibling.querySelectorAll('ul.child > li')) {
	            const el = sibling.querySelector('a');
	            if (el !== target) {
	              el.classList.add('half-opacity');
	              el.classList.remove('full-opacity');
	            }
	          }
	        } else if(el.previousElementSibling) {
	          for (const sibling of el.previousElementSibling.querySelectorAll('ul.child > li')) {
	            const el = sibling.querySelector('a');
	            if (el !== target) {
	              el.classList.add('half-opacity');
	              el.classList.remove('full-opacity');
	            }
	          }
	        }
	      }
	      // Set half-opacity to all link in the other list

	      for (const sibling of target.parentNode.parentNode.children) {
	        const el = sibling.querySelector('a');
	        if (el !== target) {
	          el.classList.add('half-opacity');
	          el.classList.remove('full-opacity');
	        }
	      }
	    }

	    if(isLinkEl && event.target.closest('.level-2') && event.target.closest('.level-2').querySelector('.nested.is-active')) event.target.closest('.level-2').querySelector('.nested.is-active').classList.remove(isActiveClass);

	    // Hovering back on 2 lvl -- Remove half opacity if there's not an imge shown
	    if(document.querySelector('.page-header .list-wrapper:nth-child(3).is-visible .level-3') && menuWrapper.dataset.open !== "3") {
	      for (const linkEl of document.querySelectorAll('.page-header .list-wrapper:nth-child(3).is-visible .level-3 li a')) {
	        linkEl.classList.remove('half-opacity');
	      }
	    }

	    if(isLinkEl && target.nextElementSibling) {
	      menuWrapper.dataset.open = "2";
	      let prevActiveEl;
	      const siblingList = target.nextElementSibling;
	      event.preventDefault();
	      target.classList.add(isActiveClass);
	      // Show image
	      if(target.dataset.img) {
	        imgWrapper.style.backgroundImage = `url('${target.dataset.img}')`;
	        if(target.dataset.url) {
	        	imgWrapper.innerHTML = `<a href="${target.dataset.url}"></a>`;
	        } else {
	        	imgWrapper.innerHTML = `<a class="no-link" href="javascript:void(0);"></a>`;
	        }
	        imgWrapper.classList.add(isVisibleClass);
	        menuWrapper.dataset.open = parseInt(menuWrapper.dataset.open) < 3 ? + (parseInt(menuWrapper.dataset.open)+1) : 3;
	      } else {
	        // Hide image
	        imgWrapper.style.backgroundImage = '';
	        imgWrapper.innerHTML = '';
	        imgWrapper.classList.remove(isVisibleClass);
	      }
	      const cloneSiblingList = siblingList.cloneNode(true);
	      subMenuWrapper3.innerHTML = "";
	      subMenuWrapper3.append(cloneSiblingList);

	      // Check Height
	      if(subMenuWrapper3.querySelectorAll('.inner-parent').length > 1 && (subMenuWrapper3.querySelector('.level-3').scrollHeight > (window.innerHeight - document.querySelector('.level-2').offsetHeight))) {
	        subMenuWrapper3.querySelectorAll('.inner-parent')[1].style.margin = '150px 0 0';
	      }
	      // Check Height

	      listWrapper3.classList.add(isVisibleClass);
	      // return;
	    } else {
	      // Close 3rd level
	      if(isLinkEl) {
	        menuWrapper.dataset.open = "1";
	        listWrapper3.classList.remove(isVisibleClass);
	        subMenuWrapper3.innerHTML = "";
	        // Show image
	        if(target.dataset.img) {
	          imgWrapper.style.backgroundImage = `url('${target.dataset.img}')`;
	          if(target.dataset.url) {
	          	imgWrapper.innerHTML = `<a href="${target.dataset.url}"></a>`;
	          } else {
	          	imgWrapper.innerHTML = `<a class="no-link" href="javascript:void(0);"></a>`;
	          }
	          imgWrapper.classList.add(isVisibleClass);
	          menuWrapper.dataset.open = parseInt(menuWrapper.dataset.open) === 1 ? 1.5 : 3;
	          return;
	        }
	        // Hide image
	        imgWrapper.style.backgroundImage = '';
	        imgWrapper.innerHTML = '';
	        imgWrapper.classList.remove(isVisibleClass);
	      }
	    }
	  }

	  function openDesktopRdLevel(event) {
	    if(!event.isTrusted || menuWrapper.classList.contains('is-closing') || !event.target.tagName.toLowerCase() === "a" || event.target.matches('.page-header .list-wrapper:nth-child(3).is-visible')) return;

	    const target = event.target;

      if(false) {
  	    const isLinkEl = target.tagName.toLowerCase() === "a";

  	    if(isLinkEl && event.target.closest('.level-3') && event.target.closest('.level-3').querySelector(`.${isActiveClass}`)) event.target.closest('.level-3').querySelector(`.${isActiveClass}`).classList.remove(isActiveClass);

  	    if(isLinkEl) {
  	      target.classList.remove('half-opacity');
  	      target.classList.add('full-opacity');

  	      // Set opacity to all link in the other list
  	      if(target.closest('.level-3').children.length > 1) {
  	        const el = target.parentElement.parentElement.parentElement;
  	        if(el.nextElementSibling) {
  	          for (const sibling of el.nextElementSibling.querySelectorAll('ul.inner-child > li')) {
  	            const el = sibling.querySelector('a');
  	            if (el !== target) {
  	              el.classList.add('half-opacity');
  	              el.classList.remove('full-opacity');
  	            }
  	          }
  	        } else if(el.previousElementSibling) {
  	          for (const sibling of el.previousElementSibling.querySelectorAll('ul.inner-child > li')) {
  	            const el = sibling.querySelector('a');
  	            if (el !== target) {
  	              el.classList.add('half-opacity');
  	              el.classList.remove('full-opacity');
  	            }
  	          }
  	        }
  	      }
  	      // Set half-opacity to all link in the other list

  	      for (const sibling of target.parentNode.parentNode.children) {
  	        const el = sibling.querySelector('a');
  	        if (el !== target) {
  	          el.classList.add('half-opacity');
  	          el.classList.remove('full-opacity');
  	        }
  	      }
  	    }
      }

	    // Show image
	    if(event.target.dataset.img) {
	      event.target.classList.add(isActiveClass);
	      imgWrapper.style.backgroundImage = `url('${event.target.dataset.img}')`;
	      if(target.dataset.url) {
	      	imgWrapper.innerHTML = `<a href="${target.dataset.url}"></a>`;
	      } else {
	      	imgWrapper.innerHTML = `<a class="no-link" href="javascript:void(0);"></a>`;
	      }
	      menuWrapper.dataset.open = parseInt(menuWrapper.dataset.open) < 3 ? + (parseInt(menuWrapper.dataset.open)+1) : 3;
	      imgWrapper.classList.add(isVisibleClass);
	      return;
	    }
	    // Hide image
	    imgWrapper.style.backgroundImage = '';
	    imgWrapper.innerHTML = '';
	    imgWrapper.classList.remove(isVisibleClass);
	    menuWrapper.dataset.open = "2";
	  }

	  function closeDesktopMenu() {
	    // Close all and remove active class to main menu
	    if(!event.isTrusted || !document.querySelector(".list-wrapper.is-visible")) return;
	    menuWrapper.classList.add('is-closing');
	    let activePanels = [...document.querySelectorAll(".list-wrapper.is-visible")].reverse();

	    activePanels[activePanels.length - 1].addEventListener('transitionend', () => {
			setTimeout(() => {
				menuWrapper.classList.remove('is-closing','is-active-visible');
				document.querySelector('#section-header').classList.remove('Header--is-active-visible');
			}, 100);
	    }, {once: true});

	    activePanels.forEach(panel => {
	      if(panel.dataset.type === 'img') {
	        imgWrapper.style.backgroundImage = '';
	        imgWrapper.innerHTML = '';
	      }
	      panel.classList.remove(isVisibleClass);
	      menuWrapper.dataset.open = parseInt(menuWrapper.dataset.open) === 1.5 ? 1 : ((parseInt(menuWrapper.dataset.open)-1) < 0) ? 0 : (parseInt(menuWrapper.dataset.open)-1);
	    });
	    if(document.querySelector('.level-1 > li > a.is-active')) document.querySelector('.level-1 > li > a.is-active').classList.remove(isActiveClass);
	    if(document.querySelector('.level-2 > li > a.is-active')) document.querySelector('.level-2 > li > a.is-active').classList.remove(isActiveClass);
	    menuWrapper.dataset.open = "0";
	    menuBackdrop.classList.remove('is-active');

      document.querySelectorAll('.menu.level-1 li a').forEach(a => {
        if(a.matches('.is-current-parent') || a.matches('.is-current-ancestor') || a.dataset.active) a.classList.add(isActiveClass);
      });

	  }

	  function isNode(o){
  	    return (
  	      typeof Node === "object" ? o instanceof Node :
  	      o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName==="string"
  	    );
  	  }

  	  function isNode(o){
	    return (
	      typeof Node === "object" ? o instanceof Node :
	      o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName==="string"
	    );
	  }

	  function resetMobileMenuPanels() {
	    if(listWrapper2) listWrapper2.classList.remove(isVisibleClass);
	    if(listWrapper3) listWrapper3.classList.remove(isVisibleClass);
	    if(subMenuWrapper2) subMenuWrapper2.innerHTML = '';
	    if(subMenuWrapper3) subMenuWrapper3.innerHTML = '';
	    if(menuWrapper) menuWrapper.dataset.open = '0';
	    if(level1Links) {
	      for(const level1Link of level1Links) {
	        level1Link.classList.remove(isActiveClass);
	      }
	    }
	  }

	  function transitionedMobileMenu() {
		clearMobileMenuCloseScheduled();
		menuWrapper.classList.remove('mobile-is-closing',isVisibleClass);
		resetMobileMenuPanels();
	  }

	 //  function transitionedMobileMenuSt() {
		// menuWrapper.classList.remove(isVisibleClass);
		// // menuWrapper.classList.remove('mobile-is-closing');
	 //  }

	 //  function transitionedMobileMenuNd() {
		// // menuWrapper.classList.toggle(isVisibleClass);
		// menuWrapper.classList.remove('mobile-is-closing',isVisibleClass);
	 //  }

	  function clearMobileMenuCloseScheduled() {
	    if(mobileMenuCloseTimer) {
	      clearTimeout(mobileMenuCloseTimer);
	      mobileMenuCloseTimer = null;
	    }
	  }

	  function scheduleMobileMenuCloseFinish(closeToken) {
	    clearMobileMenuCloseScheduled();
	    const finishIfClosing = () => {
	      if(closeToken !== mobileMenuCloseToken) return;
	      if(!menuWrapper.classList.contains('mobile-is-closing')) return;
	      transitionedMobileMenu();
	    };
	    const onMenuTransitionEnd = (event) => {
	      if(event.target !== menuWrapper || event.propertyName !== 'transform') return;
	      menuWrapper.removeEventListener('transitionend', onMenuTransitionEnd);
	      finishIfClosing();
	    };
	    menuWrapper.addEventListener('transitionend', onMenuTransitionEnd);
	    mobileMenuCloseTimer = setTimeout(() => {
	      mobileMenuCloseTimer = null;
	      finishIfClosing();
	    }, 650);
	  }

	  function toggleMobileMenu(el) {

  	    if(menuWrapper.classList.contains(isVisibleClass)) {
  	    	const closeToken = ++mobileMenuCloseToken;
  	    	resetMobileMenuPanels();
  	    	menuWrapper.classList.add('mobile-is-closing');
  	    	/* Drop menu-open immediately so white safe-area fills don't flash over the page while the drawer slides out. */
  	    	document.documentElement.classList.remove('menu-open');
  	    	scheduleMobileMenuCloseFinish(closeToken);
  	    	const pageOverlay = document.querySelector('.PageOverlay');
  	    	if(pageOverlay) pageOverlay.classList.remove('is-visible');
          setTimeout(() => document.documentElement.classList.remove('no-scroll'), 350);
  	    } else {
  	    	mobileMenuCloseToken++;
  	    	clearMobileMenuCloseScheduled();
  	    	menuWrapper.classList.remove('mobile-is-closing');
	    	menuWrapper.classList.add(isVisibleClass);
          const pageOverlay = document.querySelector('.PageOverlay');
          const isMobileMenu = window.innerWidth <= 1024 || document.documentElement.classList.contains('tablet');
          if(pageOverlay && !isMobileMenu) {
            pageOverlay.classList.add('is-visible');
          } else if(pageOverlay && isMobileMenu) {
            pageOverlay.classList.remove('is-visible');
          }
	    	  document.documentElement.classList.add('no-scroll','menu-open');
  	    }
	  }

	  function backOneLevel() {
	  	console.log('back');
	    menuWrapper.dataset.open = parseInt(menuWrapper.dataset.open) - 1;
	    const parent = this.closest(".list-wrapper");
	    parent.classList.remove(isVisibleClass);
	    parent.previousElementSibling.querySelector(".is-active").classList.remove(isActiveClass);
	  }

	  function openMobileStLevel(event) {
	    const siblingList = event.target.nextElementSibling;
	    if(siblingList) {
	      menuWrapper.dataset.open = "1";
	      event.preventDefault();
	      event.target.classList.add(isActiveClass);
	      const cloneSiblingList = siblingList.cloneNode(true);
	      subMenuWrapper2.innerHTML = "";
	      subMenuWrapper2.append(cloneSiblingList);
	      listWrapper2.querySelector('.back-one-level span').textContent = event.target.textContent;
	      listWrapper2.classList.add(isVisibleClass);
	      mobileMenuHeight(window.innerHeight,subMenuWrapper2);
	    }
	  }

	  function openMobileNdLevel(event) {
	    const target = event.target;
	    if(target.tagName.toLowerCase() === "a" && target.nextElementSibling) {
	      menuWrapper.dataset.open = "2";
	      const siblingList = target.nextElementSibling;
	      event.preventDefault();
	      target.classList.add(isActiveClass);
	      const cloneSiblingList = siblingList.cloneNode(true);
	      subMenuWrapper3.innerHTML = "";
	      subMenuWrapper3.append(cloneSiblingList);
	      listWrapper3.querySelector('.back-one-level span').textContent = event.target.textContent;
	      listWrapper3.classList.add(isVisibleClass);
	      mobileMenuHeight(window.innerHeight,subMenuWrapper3);
	    }
	  }

	  function mobileMenuHeight(h,el) {
	  	if(!el) return;
	  	el.style.height = `${h-61}px`;
	  	const subMenu = el.querySelector('.sub-menu');
	  	if(subMenu) subMenu.style.height = `${h-61}px`;
	  }

	  function closeDesktopOnClickOutside(event) {
	    if(!event.target.matches('.level-1') && !event.target.matches('.menu-wrapper')) return;
	    closeDesktopMenu();
	  }

	  function closeMenuOnClickX() {
	  	const el = event.currentTarget;
	  	if(window.innerWidth <= 1024 || document.documentElement.classList.contains('tablet')) {
	    	toggleMobileMenu(el);
	    	return;
	    }
	    closeDesktopMenu();
	  }

	  function handleMenuScrollbarDesktop() {
	    if(document.documentElement.classList.contains('touch') || (window.Scrollbar && window.Scrollbar.getAll().length)) return;

	    let scrollbarLvl2 = window.Scrollbar,
	        scrollbarLvl3 = window.Scrollbar;

	    scrollbarLvl2.init(listWrapper2);
	    scrollbarLvl3.init(listWrapper3);

	    // console.log('test scrollbar created LVL2:',scrollbarLvl2);
	    // console.log('test scrollbar created LVL3:',scrollbarLvl3);

	    // menuDesktopScrollbar = [listWrapper2, listWrapper3];
	  }
	/* Listener Functions */

	/* Style Functions */
	  function additionalMenuStyle() {
	    if(!pageHeader.querySelector('.link--to-bottom')) return;

	    const level2NewListStart = `<ul class="child">`,
	    	level3NewListStart = `<ul class="inner-child">`,
	    	level2_3NewListEnd = `</ul>`;

	    // pageHeader.querySelectorAll('.level-2 .child > li > a').forEach(el => {
	    pageHeader.querySelectorAll('.level-2').forEach(panel => {
	    	let list_html = level2NewListStart;
	    	panel.querySelectorAll('.child > li > a').forEach(el => {
		    	if(el.classList.contains('link--to-bottom')) {
		    		list_html += el.parentElement.outerHTML;
		    		el.parentElement.remove();
		    	}
	    	});
	    	list_html += level2_3NewListEnd;
	    	const warpper = document.createElement('li');
	    	warpper.classList.add('parent');
	    	warpper.innerHTML = list_html;
	    	panel.appendChild(warpper);
	    });

        pageHeader.querySelectorAll('.level-3').forEach(panel => {
        	let list_html = level3NewListStart;
        	panel.querySelectorAll('.inner-child > li > a').forEach(el => {
    	    	if(el.classList.contains('link--to-bottom')) {
    	    		list_html += el.parentElement.outerHTML;
    	    		el.parentElement.remove();
    	    	}
        	});
        	list_html += level2_3NewListEnd;
        	const warpper = document.createElement('li');
        	warpper.classList.add('inner-parent');
        	warpper.innerHTML = list_html;
        	panel.appendChild(warpper);
        });

	    // level2NewList += `</ul></li>`;
	    // console.log(`level2 special links HTML: ${level2NewList}`);

	    // pageHeader.querySelectorAll('.level-3 .inner-child > li > a').forEach(el => {
	    // 	if(el.classList.contains('link--to-bottom')) {
	    // 		level3NewList += el.parentElement.outerHTML;
	    // 		el.parentElement.remove();
	    // 	}
	    // });

	    // level3NewList += `</ul></li>`;
	    // console.log(`level3 special links HTML: ${level3NewList}`);

	    /*
	    let normalLinks = 0,
	        specialLinks = 0;

	    // Bisogna prendere tutte le level-2 e di ognuna prendere i primi link
	    for(const level2Link of level2Links) {
	      if(level2Link.parentElement.classList.contains('link--to-bottom')) {
	        specialLinks = specialLinks + 1;
	      } else {
	        normalLinks = normalLinks + 1;
	      }
	    }

	    console.log(`level2 normal links: ${normalLinks}, specialLinks: ${specialLinks}`);

	    normalLinks = 0;
	    specialLinks = 0;

	    // Bisogna prendere tutte le level-3 e di ognuna prendere i primi link

	    for(const level3Link of level3Links) {
	      if(level3Link.parentElement.classList.contains('link--to-bottom')) {
	        specialLinks = specialLinks + 1;
	      } else {
	        normalLinks = normalLinks + 1;
	      }
	    }

	    console.log(`level3 normal links: ${normalLinks}, specialLinks: ${specialLinks}`);
	    */
	  }
	/* Style Functions */

  /* Manage active state */
    function activeMenu() {
      if(!current_location_pathname) return;
      if(current_location_pathname.indexOf('/blogs/news-and-events') > -1 && document.body.matches('.template-article')) {
        addActiveClassMenu('/blogs/news-and-events');
        return;
      }
      addActiveClassMenu(null);
    }

    function addActiveClassMenu(newVal) {
      if(newVal) current_location_pathname = newVal;
      document.querySelectorAll('.menu-wrapper li:not(.view-all) a').forEach(a => {
        const h = a.getAttribute('href');
        if(h === current_location_pathname) {
          // console.log("MATCH: "+h+" vs. "+current_location_pathname);
          // debugger;
          if(a.parentElement.classList.contains('view-all')) return false;
          a.classList.add('is-current','is-active');
          a.dataset.active = 'true';
          const rd = a.closest('.level-3'),
              nd = a.closest('.level-2');
          if(rd){
            // debugger;
            /* Wrong */
              //rd.closest('.level-2').querySelector('.child li a').classList.add('is-current-parent','is-active');
              // rd.closest('.level-1').querySelector('li a').classList.add('is-current-ancestor','is-active');
            /* Wrong */
            rd.closest('.level-3').previousElementSibling.classList.add('is-current-parent','is-active');
            rd.closest('.level-2').previousElementSibling.classList.add('is-current-parent','is-active');
          } else if(nd){
            nd.closest('.sub-menu.level-2').previousElementSibling.classList.add('is-current-parent','is-active');
          }
          return false;
        }
      });
    }
  /* Manage active state */

  /* Manage Customer Menu */
    function customerMenuDesktopEventsIn(event) {
      if(!event.isTrusted || !document.documentElement.classList.contains('desktop')) return;
      const target = event.target,
        isLinkEl = target.tagName.toLowerCase() === "a";
      if(isLinkEl) {
        target.classList.remove('half-opacity');
        target.classList.add('full-opacity');
        // Set opacity to all link in the other list
        if(target.closest('.customer-navigation .items-wrapper').children.length > 1) {
          const el = target.parentElement.parentElement;
          for (const sibling of el.querySelectorAll('li')) {
            const el = sibling.querySelector('a');
            if (el !== target) {
              el.classList.add('half-opacity');
              el.classList.remove('full-opacity','is-active');
            }
          }
        }
        // Set half-opacity to all link in the other list
      }
    }

    function customerMenuDesktopEventsOut(event) {
      if(!event.isTrusted || !document.documentElement.classList.contains('desktop')) return;
      const _ct = event.currentTarget.querySelector('a[data-active="true"]');
      if(_ct) {
        for (const sibling of event.currentTarget.querySelectorAll('li')) {
          const el = sibling.querySelector('a');
          if(el !== _ct) {
            el.classList.remove('half-opacity','full-opacity','is-active');
          } else {
            el.classList.remove('half-opacity','full-opacity');
            el.classList.add('is-active');
          }
        }
      } else {
        for (const sibling of event.currentTarget.querySelectorAll('li')) {
          sibling.querySelector('a').classList.remove('half-opacity','full-opacity','is-active');
        }
      }
    }

    function handleCustomerMenu() {
      if(!document.body.classList.contains('customer-logged-in') || !current_location_pathname) return;
      if(current_location_pathname.indexOf('/account/orders/') > -1 && document.body.matches('.template-order')) {
        current_location_pathname = '/account?view=orders_history';
      } else {
        current_location_pathname += window.location.search;
      }
      document.querySelectorAll('#sidebar-customer .customer-navigation a').forEach(a => {
        const h = a.getAttribute('href');
        if(h === current_location_pathname) {
          a.classList.add('is-active');
          a.dataset.active = 'true';
          return false;
        }
      });
      if(!document.documentElement.classList.contains('desktop')) return;
      document.querySelector('#sidebar-customer .customer-navigation').addEventListener("mouseover", customerMenuDesktopEventsIn);
      document.querySelector('#sidebar-customer .customer-navigation').addEventListener("mouseout", customerMenuDesktopEventsOut);
    }
  /* Manage Customer Menu */


	function cpc() {

	  detectTouchDevice();

	  window.addEventListener('keyup', keyUpHandler);
	  window.addEventListener('resize', customResizeHandler);
	  window.addEventListener('orientationchange', customOrientationchangeHandler);

	  pageHeader = document.querySelector(".page-header");
	  if(!pageHeader) return;

	  menuWrapper = pageHeader.querySelector(".MenuMobile") || pageHeader.querySelector(".menu-wrapper");
	  level1Links = menuWrapper ? menuWrapper.querySelectorAll(".level-1 > li > a") : [];
	  level2Links = menuWrapper ? menuWrapper.querySelectorAll(".level-2 > li > a") : [];
	  level3Links = menuWrapper ? menuWrapper.querySelectorAll(".level-3 > li > a") : [];
	  listWrapper2 = menuWrapper ? menuWrapper.querySelector(".list-wrapper:nth-child(2)") : null;
	  listWrapper3 = menuWrapper ? menuWrapper.querySelector(".list-wrapper:nth-child(3)") : null;
	  imgWrapper = menuWrapper ? menuWrapper.querySelector(".list-wrapper:nth-child(4)") : null;
	  subMenuWrapper2 = listWrapper2 ? listWrapper2.querySelector(".sub-menu-wrapper") : null;
	  subMenuWrapper3 = listWrapper3 ? listWrapper3.querySelector(".sub-menu-wrapper") : null;
	  backOneLevelBtns = menuWrapper ? menuWrapper.querySelectorAll(".back-one-level") : [];
	  closeX = menuWrapper ? menuWrapper.querySelector(".close") : null;
	  menuBackdrop = document.querySelector(".menu-backdrop");
    pageBackdrop = document.querySelector(".PageOverlay");
	  isVisibleClass = "is-visible";
	  isActiveClass = "is-active";

	  // Mobile-only helpers (safe no-ops if wrappers missing)
	  if(menuWrapper) additionalMenuStyle();

	  if(closeX) closeX.addEventListener("click", closeMenuOnClickX);

    handleCustomerMenu();

	  if(window.innerWidth <= 1024 || document.documentElement.classList.contains('tablet')) {
	    addMainMenuMobileEvents();
	    return;
	  }

	  desktopMobileEvents = true;
	  addMainMenuDesktopEvents();
	}

	window.addEventListener('DOMContentLoaded',cpc);
/* Menu -------------------------------------------------------------------- */

/* Homepage - First Block Header Color */
	window.addEventListener('DOMContentLoaded', firstBlockHeaderColorHP);

	function firstBlockHeaderColorHP() {
		if(!document.body.classList.contains('template-index')) return;
		if(document.querySelector('.template-index #main > .shopify-section').classList.contains('shopify-section--slideshow')) { // First block is slider
			document.querySelector('.Header').dataset.color = document.querySelector('.template-index #main > .shopify-section .slick-active').dataset.color;
			return;
		}
		// First block is not slider
		document.querySelector('.Header').dataset.color = document.querySelector('#main > .shopify-section > section').dataset.color;
	}
/* Homepage - First Block Header Color */

/* Custom Accordion: Footer - Cart - Product Info Tabs -------------------------------------------------------------------- */
	window.addEventListener('DOMContentLoaded', mobileAccordion);

	function mobileAccordion() {
		const els = [...document.querySelectorAll('.open-toggle > .column-title')];
		els.forEach(el => {
			el.addEventListener('click', handleCustomAccorion)
			if(el.nextElementSibling.matches('.active')) el.nextElementSibling.style.height = `${el.nextElementSibling.offsetHeight}px`;
		});
	}

	function handleCustomAccorion(e) {
		e.preventDefault();
		const nEl = e.currentTarget.nextElementSibling;
		if(!nEl.classList.contains('active')) {
			const p = e.currentTarget.closest('.columns-wrapper');
			const tEl = p.querySelector('.open-toggle.active');
			if(tEl) {
				const tnEl = tEl.querySelector('.no-bullet.active');
				closeCustomAccordion(tEl,tnEl);
			}
			e.currentTarget.closest('.open-toggle').classList.toggle('active');
			nEl.classList.toggle('active');
			nEl.style.height = 'auto';
			const _h = nEl.clientHeight + 'px';
			nEl.style.height = '0px';
			setTimeout(function () {
			  nEl.style.height = _h;
			}, 0);
		} else {
			closeCustomAccordion(e.currentTarget,nEl);
		}
	}

	function closeCustomAccordion(triggerEl,listEl) {
		triggerEl.closest('.open-toggle').classList.toggle('active');
		listEl.style.height = '0px';
		listEl.addEventListener('transitionend', function () {
		  listEl.classList.remove('active');
		}, {
		  once: true
		});
	}
/* Custom Accordion: Footer - Cart - Product Info Tabs -------------------------------------------------------------------- */

/* Forms - Customer Gender */
	window.addEventListener('DOMContentLoaded', customerFormGender);

	function customerFormGender() {
		if(!document.querySelector('.gender-wrapper')) return;
		var normalizeGenderValue = function(rawValue) {
			var normalized = (rawValue || '').toString().trim().toUpperCase().slice(0, 1);
			return normalized === 'M' || normalized === 'F' ? normalized : '';
		};
		var setGenderTagValue = function(inputEl, tagKey, genderValue) {
			if(!inputEl || !genderValue) return;
			var tagsValue = inputEl.value || '';
			var separator = tagsValue.endsWith(',') || !tagsValue ? '' : ',';
			if(/gender:[^,]*/i.test(tagsValue)) {
				inputEl.value = tagsValue.replace(/gender:[^,]*/i, `${tagKey}:${genderValue}`);
				return;
			}
			inputEl.value = `${tagsValue}${separator}${tagKey}:${genderValue},`;
		};

		document.querySelectorAll('.gender-wrapper input[type="radio"]').forEach(el => {
			el.addEventListener('change', e => {
				var val = normalizeGenderValue(e.currentTarget.value);
				if(!val || (val !== 'M' && val !== 'F')) return;
				if(e.currentTarget.closest('form').querySelector('input[name="contact[tags]"]')) {
					var contactTagsInput = e.currentTarget.closest('form').querySelector('input[name="contact[tags]"]');
					setGenderTagValue(contactTagsInput, 'gender', val);
				} else if (e.currentTarget.closest('form').querySelector('input[name="customer[tags]"]')) {
					var customerTagsInput = e.currentTarget.closest('form').querySelector('input[name="customer[tags]"]');
					setGenderTagValue(customerTagsInput, 'Gender', val);
				}
			});
		});

		var createCustomerForm = document.querySelector('#create_customer');
		if(createCustomerForm) {
			createCustomerForm.addEventListener('submit', function() {
				var checkedGender = createCustomerForm.querySelector('.gender-wrapper input[type="radio"]:checked');
				var val = normalizeGenderValue(checkedGender ? checkedGender.value : '');
				if(!val) return;
				var customerTagsInput = createCustomerForm.querySelector('input[name="customer[tags]"]');
				setGenderTagValue(customerTagsInput, 'Gender', val);
			});
		}
	}
/* Forms - Customer Gender */

/* Custom Widget - Small Slider with Progress Bar */

let flktySlidersWithBar = [];
let flickityRefreshRaf = null;
let flickityWasMobile = null;

window.addEventListener('DOMContentLoaded', () => {
	flickityWasMobile = isCustomFlickityMobile();
	initSlidersWithBar();
});
window.addEventListener('resize', scheduleCustomFlickityResize);
window.addEventListener('orientationchange', scheduleCustomFlickityResize);
document.addEventListener('breakpoint:changed', reinitAllCustomFlickitySliders);

function isCustomFlickityMobile() {
	return window.innerWidth <= 1024 || document.documentElement.classList.contains('tablet');
}

/**
 * Continuous resize: cheap flkty.resize() only.
 * Crossing 1024 / tablet: full destroy+reinit (options + CSS breakpoints).
 */
function scheduleCustomFlickityResize() {
	if (flickityRefreshRaf !== null) return;
	flickityRefreshRaf = requestAnimationFrame(() => {
		flickityRefreshRaf = null;
		const isMobile = isCustomFlickityMobile();
		if (flickityWasMobile !== null && isMobile !== flickityWasMobile) {
			reinitAllCustomFlickitySliders();
			return;
		}
		flickityWasMobile = isMobile;
		resizeAllFlickitySliders();
	});
}

function resizeAllFlickitySliders() {
	if (!window.Flickity) return;
	document.querySelectorAll('.flickity-enabled').forEach((carousel) => {
		const flkty = Flickity.data(carousel);
		if (!flkty) return;
		try { flkty.resize(); } catch (e) {}
	});
}

function reinitAllCustomFlickitySliders() {
	flickityWasMobile = isCustomFlickityMobile();

	try {
		handleResize();
	} catch (e) { /* slideshow-with-bar */ }

	if (typeof window.reinitImageSideSliders === 'function') {
		try { window.reinitImageSideSliders(); } catch (e) {}
	}
	if (typeof window.reinitTwoSidedProductListSliders === 'function') {
		try { window.reinitTwoSidedProductListSliders(); } catch (e) {}
	}
	if (typeof window.reinitTabbedSliders === 'function') {
		try { window.reinitTabbedSliders(); } catch (e) {}
	}
}

/**
 * Inizializza TUTTE le sezioni [data-section-type="slideshow-with-bar"].
 */
function initSlidersWithBar() {
	setTimeout(() => {
		const sections = document.querySelectorAll('[data-section-type="slideshow-with-bar"]');
		if (sections.length) {
			sections.forEach((el) => initSingleSlideshowWithBar(el));
		}
	}, 100);
}

/**
 * Inizializza una singola sezione.
 */
function initSingleSlideshowWithBar(el) {
	// Calcoliamo showArrows in base a:
	// 1) Larghezza <= 1024  => "mobile"
	// 2) Body contiene una classe che include "bespoke"
	const isMobile = window.innerWidth <= 1024;
	const hasBespoke = [...document.body.classList].some(cls => cls.includes('bespoke'));

	// Se è mobile+bespoke => NIENTE frecce
	const showArrows = !(isMobile && hasBespoke);

	// Crea Flickity
	const flkty = new Flickity(`#${el.id} .carousel`, {
		initialIndex: 0,
		wrapAround: false,
		cellAlign: "left",
		contain: true,
		pageDots: false,
		freeScroll: true,
		imagesLoaded: true,
		percentPosition: false,
		prevNextButtons: showArrows,  // Se false, Flickity non crea le frecce
		arrowShape: "M18.7,68.7L0,50l18.7-18.7l4.7,4.7L12.4,46.9l87.6,0v6.6l-87.2,0L23.3,64L18.7,68.7z",
		on: {
			ready() {
				if (el.classList.contains('shopify-section--product-recommendations')) {
					document.dispatchEvent(new Event('relatedProdsLoaded'));
				}
				// Se Flickity avesse già creato i pulsanti, ma showArrows == false, li rimuoviamo dal DOM
				if (!showArrows) removeArrows(el);
			},
			scroll(progress) {
				progress = Math.max(0, Math.min(1, progress));
				const bar = el.querySelector('.progress-bar');
				if (bar) {
					bar.style.width = (progress * 100) + '%';
				}
				// Se i pulsanti ci sono e la sezione è quasi a fine scroll, disabilitiamo "next"
				const btnNext = el.querySelector('.flickity-prev-next-button.next');
				if (btnNext) {
					if (progress >= 0.99) {
						btnNext.disabled = true;
					} else {
						btnNext.removeAttribute('disabled');
					}
				}
			}
		}
	});

	// Salviamo i riferimenti
	flktySlidersWithBar.push({ el, flkty, showArrows });
}

/**
 * Rimuove manualmente i pulsanti prev/next dal DOM, se Flickity li ha generati.
 */
function removeArrows(sectionEl) {
	const btns = sectionEl.querySelectorAll('.flickity-prev-next-button');
	btns.forEach(btn => btn.remove());
}

/**
 * Al resize: distrugge e ricrea Flickity su TUTTE le sezioni, così da
 * tenere sincronizzato lo stato (show/hide arrows) rispetto a mobile+bespoke.
 */
function handleResize() {
	flktySlidersWithBar.forEach((sliderData) => {
		const { flkty } = sliderData;
		if (flkty && typeof flkty.destroy === 'function') {
			try { flkty.destroy(); } catch (e) {}
		}
	});

	flktySlidersWithBar = [];

	const sections = document.querySelectorAll('[data-section-type="slideshow-with-bar"]');
	sections.forEach((el) => {
		const carousel = el.querySelector('.carousel');
		if (!carousel || !window.Flickity) return;
		const existing = Flickity.data(carousel);
		if (existing) {
			try { existing.destroy(); } catch (e) {}
		}
		initSingleSlideshowWithBar(el);
	});
}

/* Custom Widget - Small Slider with Progress Bar */

/* Custom Widget - Image Side Slider with Progress Bar */
	window.addEventListener('DOMContentLoaded', imageSideSliderProgressBar);

	function imageSideSliderProgressBar() {
		const initAll = () => {
			if (!window.Flickity) return;
			document.querySelectorAll('[data-section-type="image-side-slider"]').forEach(el => {
				const carousel = el.querySelector('.carousel');
				if (!carousel) return;

				const existing = Flickity.data(carousel);
				if (existing) {
					try { existing.destroy(); } catch (e) {}
				}

				const showArrows = el.getAttribute('data-show-arrows') !== 'false';

				new Flickity(carousel, {
					initialIndex: 0,
					contain: true,
					wrapAround: false,
					cellAlign: 'left',
					pageDots: false,
					prevNextButtons: showArrows,
					freeScroll: true,
					imagesLoaded: true,
					percentPosition: false,
					arrowShape: 'M18.7,68.7L0,50l18.7-18.7l4.7,4.7L12.4,46.9l87.6,0v6.6l-87.2,0L23.3,64L18.7,68.7z',
					on: {
						scroll: function(progress) {
							progress = Math.max(0, Math.min(1, progress));
							const bar = el.querySelector('.progress-bar');
							if (bar) bar.style.width = progress * 100 + '%';
							if (!showArrows) return;
							const nextBtn = el.querySelector('.flickity-prev-next-button.next');
							if (!nextBtn) return;
							if (progress >= 0.99) {
								nextBtn.disabled = true;
							} else {
								nextBtn.removeAttribute('disabled');
							}
						}
					}
				});
			});
		};

		window.reinitImageSideSliders = initAll;
		setTimeout(initAll, 100);
	}
/* Custom Widget - Image Side Slider with Progress Bar */

/* Custom Widget - 2 Sided Product List Slider */
	window.addEventListener('DOMContentLoaded', twoSidedProductListSlider);

	function twoSidedProductListSlider() {
		const mq = window.matchMedia('(max-width: 1024px)');
		const isMobileViewport = () => mq.matches || document.documentElement.classList.contains('tablet');

		const init = () => {
			const isMobile = isMobileViewport();
			document.querySelectorAll('[data-section-type="2-sided-product-list"]').forEach(el => {
				const carousel = el.querySelector('.TwoSidedProductList__Carousel');
				if (!carousel || !window.Flickity) return;

				const existing = Flickity.data(carousel);
				if (existing) {
					try { existing.destroy(); } catch (e) {}
				}

				const isSingle = carousel.classList.contains('TwoSidedProductList__Carousel--single')
					|| carousel.querySelectorAll('.TwoSidedProductList__Item').length === 1;

				/* Single product: CSS centering only — Flickity was hiding the cell */
				if (isSingle) return;

				new Flickity(carousel, {
					initialIndex: 0,
					wrapAround: false,
					cellAlign: isMobile ? 'center' : 'left',
					contain: !isMobile,
					pageDots: false,
					prevNextButtons: false,
					freeScroll: !isMobile,
					imagesLoaded: true,
					percentPosition: false
				});
			});
		};

		window.reinitTwoSidedProductListSliders = init;

		const boot = () => {
			init();
			/* resize handled globally by refreshAllCustomFlickitySliders */
			if (typeof mq.addEventListener === 'function') {
				mq.addEventListener('change', init);
			} else if (typeof mq.addListener === 'function') {
				mq.addListener(init);
			}
		};

		if (window.Flickity) {
			boot();
		} else {
			window.addEventListener('load', boot, { once: true });
		}
	}
/* Custom Widget - 2 Sided Product List Slider */

/* Custom Widget - Tabbed Prods with Progress Bar */
	window.addEventListener('DOMContentLoaded', tabbedSliderProgressBar);

	function tabbedSliderProgressBar() {
		const mq = window.matchMedia('(max-width: 1024px)');
		const isMobileViewport = () => mq.matches || document.documentElement.classList.contains('tablet');

		const initSection = (parent) => {
			var _parent = parent;
			var showProgressBar = _parent.getAttribute('data-show-progress-bar') !== 'false';
			var showArrows = _parent.getAttribute('data-show-arrows') !== 'false';
			if(!_parent.querySelector('.tab-wrapper')) return;

			_parent.querySelectorAll('.tab-wrapper').forEach((el) => {
				const tabId = el.getAttribute('data-tab');
				const progressBar = el.querySelector('.progress-bar');
				const carousel = _parent.querySelector(`.tab-wrapper[data-tab="${tabId}"] .carousel`);
				if (!carousel || !window.Flickity) return;

				const existing = Flickity.data(carousel);
				if (existing) {
					try { existing.destroy(); } catch (e) {}
				}

				const isMobile = isMobileViewport();
				const cellCount = carousel.querySelectorAll('.carousel-cell').length;
				/* Mobile: start on slide 1 so left+right peeks are visible at init */
				const initialIndex = isMobile && cellCount >= 2 ? 1 : 0;
				new Flickity(carousel, {
					"initialIndex": initialIndex,
					"wrapAround": false,
					"cellAlign": isMobile ? "center" : "left",
					"contain": !isMobile,
					"pageDots": false,
					"prevNextButtons": showArrows,
					"freeScroll": !isMobile,
					"imagesLoaded": true,
					"percentPosition": false,
					"arrowShape": "M18.7,68.7L0,50l18.7-18.7l4.7,4.7L12.4,46.9l87.6,0v6.6l-87.2,0L23.3,64L18.7,68.7z",
					on: {
					    scroll: function(progress) {
					    	progress = Math.max(0, Math.min(1, progress));
							if(showProgressBar && progressBar) {
								progressBar.style.width = progress * 100 + '%';
							}
							if(showArrows) {
								const nextBtn = el.querySelector('.flickity-prev-next-button.next');
								if(!nextBtn) return;
								if(progress >= 0.99) {
								  nextBtn.disabled = true;
								} else {
								  nextBtn.removeAttribute('disabled');
								}
							}
					    },
						staticClick: function(event) {
							/**
							 * for triggering GA4 select_item event
							 **/
							let customEvent = new CustomEvent("carouselCellClickedNotDragged", {detail: event.target});
							document.dispatchEvent(customEvent)
						}
					 }
				});
			});

			if(_parent.querySelector('.tab-triggers') && !_parent.dataset.tabTriggersBound) {
				_parent.dataset.tabTriggersBound = '1';
				_parent.querySelector('.tab-triggers').addEventListener('click', e => {
					if(!e.isTrusted || !e.target.matches('.tab-trigger') || e.target.matches('.tab-trigger--is-active')) return;
					_parent.querySelector('.tab-wrapper--is-active').classList.remove('tab-wrapper--is-active');
					e.target.classList.add('tab-wrapper--is-active');
					_parent.querySelector('.tab-wrapper--visible').classList.remove('tab-wrapper--visible');
					_parent.querySelector(`.tab-wrapper[data-tab="${e.target.dataset.tab}"]`).classList.add('tab-wrapper--visible');
				});
			}
		};

		const initAll = () => {
			if(!document.querySelector('[data-section-type="tabbed-slideshow-with-bar"]')) return;
			document.querySelectorAll('[data-section-type="tabbed-slideshow-with-bar"]').forEach(initSection);
		};

		window.reinitTabbedSliders = initAll;
		setTimeout(initAll, 100);

		/* resize handled globally by refreshAllCustomFlickitySliders */
		if (typeof mq.addEventListener === 'function') {
			mq.addEventListener('change', initAll);
		} else if (typeof mq.addListener === 'function') {
			mq.addListener(initAll);
		}
	}
/* Custom Widget - Tabbed Prods with Progress Bar */

/* Custom Widget - Video on Video */
	window.addEventListener('DOMContentLoaded', video_on_video);
	function video_on_video() {
		if (window.jQuery && jQuery('.js-video__play')) {
			jQuery('.shopify-section--bspok_video_on_video .js-video__play').each(function() {
				$(this).magnificPopup({
					closeMarkup: '<button title="%title%" type="button" class="mfp-close"></button>',
					type: 'iframe',
					mainClass: 'mfp-fade',
					removalDelay: 160,
					preloader: false,
					fixedContentPos: false,
					iframe: {
						markup: '<div class="mfp-iframe-scaler">'+
							'<div class="mfp-close"></div>'+
							'<iframe class="mfp-iframe" frameborder="0" allow="autoplay" allowfullscreen></iframe>'+
							'</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
						patterns: {
							youtube: {
							index: 'youtube.com/',
								id: function(url) {
									var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
									var match = url.match(regExp);
									return (match&&match[7].length==11)? match[7] : false;
								},
								src: '//www.youtube.com/embed/%id%?autoplay=1'
							},
							vimeo: {
								index: 'vimeo.com/',
								id: function(url) {
									var m = url.match(/(https?:\/\/)?(www.)?(player.)?vimeo.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/);
									if ( !m || !m[5] ) return null;
									return m[5];
								},
								src: '//player.vimeo.com/video/%id%?autoplay=1'
							}
						},
						srcAction: 'iframe_src' // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
					},
					callbacks: {
						beforeOpen: function() {
							console.log('Start of popup initialization');
						},
					    open: function() {
					    	const triggerEl = this.ev[0];
					    	getBckVideoIndex(triggerEl,'pause');
					    	triggerEl.closest('.shopify-section--bspok_video_on_video').querySelector('.js-video__play--trigger').classList.add('playing');
							// Will fire when this exact popup is opened
							// this - is Magnific Popup object
					    },
					    beforeClose: function() {
							// Callback available since v0.9.0
							console.log('Popup close has been initiated');
						},
					    close: function() {
					    	const triggerEl = this.ev[0];
					    	getBckVideoIndex(triggerEl,'play');
					    	triggerEl.closest('.shopify-section--bspok_video_on_video').querySelector('.js-video__play--trigger').classList.remove('playing');
							// Will fire when popup is closed
					    },
					    afterClose: function() {
							console.log('Popup is completely closed');
						}
					  }
				});
			});
		}
	}
	function getBckVideoIndex(el,action) {
		const parent = el.closest('.shopify-section--bspok_video_on_video'),
			frameId = parent.querySelector('.video__iframe.loaded iframe');
		if(!frameId) return;
		const _id = frameId.id;
		let v;
		for(const property in ytPlayers) {
			if((ytPlayers[property].i.id == _id)) v = _id;
		}
		if(!v) return;
		if(action == 'pause') {
			ytPlayers[v].pauseVideo();
			return;
		}
		ytPlayers[v].playVideo();
	}
/* Custom Widget - Video on Video */

/* Custom Widget - Social Wall (InstaFeed App) */
	window.addEventListener('DOMContentLoaded', socialWall);
	var nativeXHR, socialWallInterval;

	function fetchEls() {
		console.log('fetchEls()');
		if(!document.querySelector('#insta-feed .slide-page')) {
			socialWallInterval = setInterval(() => {
				fetchEls();
				console.log('recalling fetchEls');
			},2000);
		} else {
			console.log('clear interval, no more calls to fetchEls');
			clearInterval(socialWallInterval);
			let obj = {};
			document.querySelectorAll('#insta-feed .slide-page').forEach((el,index) => obj[index] = [el.querySelector('a').getAttribute("href"),el.querySelector('img').dataset.src,el.querySelector('img').getAttribute("alt")]);
			updateSlider(obj);
		}
	}

	function updateSlider(obj) {
		let cells = ``;
		for(const i in obj) {
			cells += `<div class="carousel-cell"><a href="${obj[i][0]}" target="_blank"><img src="${obj[i][1]}" alt="${obj[i][2]}" /></a></div>`;
	    }
	    document.querySelector('[data-insta-feed] .carousel').innerHTML = cells;
	    //document.querySelector('#insta-feed').remove();
	    setTimeout(() => {
			initSocialWallSlider();
	    },100);
	}

	function initSocialWallSlider() {
		const el = document.querySelector('[data-insta-feed]'),
			progressBar = el.querySelector('.progress-bar'),
			flkty = new Flickity(`#${el.id} .carousel`, {
				"initialIndex": 0,
				"wrapAround": false,
				"cellAlign": "left",
				"contain": true,
				"pageDots": false,
				"freeScroll": true,
				"imagesLoaded": true,
				"percentPosition": false,
				"arrowShape": "M18.7,68.7L0,50l18.7-18.7l4.7,4.7L12.4,46.9l87.6,0v6.6l-87.2,0L23.3,64L18.7,68.7z",
				on: {
				    ready: function() {
				      // console.log('Flickity is ready');
				    },
				    change: function( index ) {
				      // console.log( 'Slide changed to' + index );
				    },
				    scroll: function(progress) {
				    	progress = Math.max(0, Math.min(1, progress));
						el.querySelector('.progress-bar').style.width = progress * 100 + '%';
				    }
				 }
			});
			setTimeout(() => {
				flkty.reposition();
				el.querySelector('.carousel').classList.add('loaded');
			}, 1000, el, flkty);
	}

	function newXHR() {
	  overridenXHR = new nativeXHR();

	  // ORIGINAL:
	  // overridenXHR.addEventListener("readystatechange", function (e) {

	  // MODIFIED: 11_07_2022
	  overridenXHR.addEventListener("load", function (e) {

	  	console.log('e',e.target.responseURL);
	    if(e.target.responseURL.includes('https://instafeed.nfcube.com')) {

			// ORIGINAL:
	      	// if(overridenXHR.readyState == 4) fetchEls();

			// MODIFIED: 11_07_2022
			const instafeedObject = new Promise((resolve,reject)=>{
				requestToInstafeed = overridenXHR;
				requestToInstafeed.onload = function () {
					if (requestToInstafeed.status >= 200 && requestToInstafeed.status < 300) {
						resolve(requestToInstafeed.response);
					} else {
						reject({
							status: requestToInstafeed.status,
							statusText: requestToInstafeed.statusText
						});
					}
				};
				requestToInstafeed.onerror = function () {
					reject({
						status: requestToInstafeed.status,
						statusText: requestToInstafeed.statusText
					});
				};
			});
			instafeedObject.then( fetchEls() )

	    }
	  }, false);
	  return overridenXHR;
	}

	function socialWall() {
		if(!document.querySelector('#insta-feed')) return;
		nativeXHR = window.XMLHttpRequest;
		window.XMLHttpRequest = newXHR;
	}
/* Custom Widget - Social Wall (InstaFeed App) */

/* Custom Wishlist Drawer */
	// window.addEventListener('DOMContentLoaded', customWishlist);
	// var nativeXHR, socialWallInterval;

	// function customWishlist() {
	// 	if(!document.body.classList.contains('template-product')) return;
	// 	nativeXHR = window.XMLHttpRequest;
	// 	window.XMLHttpRequest = newXHR;
	// }
/* Custom Wishlist Drawer */

/* Custom Widget - Fade Slider / Stack Slider */
	/* Prevent scroll of the page */
	/* Fixare i data-position e rimuovere tutte le cose di slick */
	window.addEventListener('DOMContentLoaded', stackSlider);

	function stackSlider() {
		if(!document.querySelector('#dp-slider')) return;

		$.fn.stack_slider = ()=>{

			function _sa(){
				$.each($('.dp_item'),(i,el)=>$(el).attr('data-position',i+1));
				const a = $("#dp-slider .dp_item:first-child").data("class");
				$("#dp-dots li").removeClass("active");
				$(`#dp-dots li[data-class="${a}"]`).addClass("active");
			}

			$(".dp-next").click(()=>{
				if(!_cV()) return;
				$("#dp-slider .dp_item:first-child").hide().appendTo("#dp-slider").fadeIn();
				_sa();
			});

			$(".dp-prev").click(()=>{
				if(!_cV()) return;
				$("#dp-slider .dp_item:last-child").hide().prependTo("#dp-slider").fadeIn();
				_sa();
			});

			function _cV(){
				return window.innerWidth < 1024 ? !0 : !1;
			}

			function _cH(){
				if(!$('#historySlider').hasClass('open')) return;
				$('#historySlider').removeClass('open');
				$('.dp_item:last-child .read-more').text($('.dp_item:last-child .read-more').attr('data-more'));
			}

			$.fn.swipe = callback => {
				let td = !1,
				op = null;
				const $el = jQuery(this);

				function _sI(e) {
					const x = e.originalEvent.pageX,
						y = e.originalEvent.pageY,
						dx = x > op.x ? "l" : "r";
					return {
						d: dx,
						o: x - op.x
					};
				}

				$el.on("touchstart mousedown",e=>{
					if(!_cV()) return;
					e.preventDefault();
					e.stopPropagation();
					td = !0;
					op = {x: e.originalEvent.pageX,y: e.originalEvent.pageY};
				});

				$el.on("touchend mouseup",()=>{
					if(!_cV()) return;
					td = !1;
					op = null;
					_fs = !0;
				});

				$el.on("touchmove mousemove",e=>{
					if(!td || !_cV()) return;
					e.preventDefault();
					e.stopPropagation();
					const i = _sI(e);
					callback(i.d, i.o);
				});

				return !0;
			};

			// disable image drag
			$('#historySlider img').on('dragstart',e=>{
				if(!_cV()) return;
				e.preventDefault();
			});

		 	// drag
			var _fs = !0;
			jQuery(".dp_item").swipe((d,o)=>{
				if(o<-30 && d ==='r' && _fs){
					_fs = !1;
					$("#dp-next").click();
					_cH();
					return;
				}
				if(o>30 && d==='l' && _fs){
					_fs = !1;
					$("#dp-prev").click();
					_cH();
					return;
				}
			});

	    };

		// if(window.innerWidth >= 1024) {
		// 	return;
		// }
		// run stack
		$("#historySlider").stack_slider();
		// run slick
		stackSliderDesktop(false);
		$(window).on('resize', () => {
		   stackSliderDesktop(true);
		});
		$('#historySlider .read-more').on('click',function(e){
			$("#historySlider").toggleClass('open');
			if($("#historySlider").hasClass('open')) {
				$(this).text($(this).attr('data-less'));
				return;
			}
			$(this).text($(this).attr('data-more'));
		});
	}

	function stackSliderStartAnimation() {
		document.querySelector('#historySlider').classList.remove('loaded');
	}

	function stackSliderStopAnimation() {
		setTimeout(() => document.querySelector('#historySlider').classList.add('loaded'), 1000);
	}

	function reorderStackSlidesDesktop() {
		// Add class to hide and load
		stackSliderStartAnimation();
		$.each($('.dp_item'),(i,el) => {
		    if(parseInt($(el).attr('data-class')) === 1) return false;
		    console.log(parseInt($(el).attr('data-class')));
		    $(el).appendTo("#dp-slider");
		});
		// Add class to show the new result
		stackSliderStopAnimation();
	}

	function reorderStackSlidesMobile() {
		// Add class to hide and load
		stackSliderStartAnimation();
		$.each($('.dp_item'),(i,el) => {
		    $(el).attr('data-position',$(el).attr('data-class'));
		    $(el).removeAttr('tabindex style role id aria-describedby')
		});
		$("#historySlider").addClass('init');
		// Add class to show the new result
		stackSliderStopAnimation();
	}

	function stackSliderDesktop(cond) {
		if($(window).width() >= 1024) {
			if($('#dp-slider').hasClass('slick-initialized')) return;
			$("#historySlider").removeClass('init');
			if(cond) reorderStackSlidesDesktop();
			// $('#dp-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
			// 	$(slick.$slides[nextSlide]).find(`.slick-dots li.slick-active`).removeClass('slick-active');
			// 	$(slick.$slides[nextSlide]).find(`.slick-dots li:nth-child(${nextSlide+1})`).addClass('slick-active');
			// });
			$('#dp-slider').on('init', function(event, slick){
				$(slick.$slides[0]).find(`.slick-dots li.slick-active`).addClass('slick--active').removeClass('slick-active');
			});
			$('#dp-slider').on('afterChange', function(event, slick, currentSlide){
				$(slick.$slides[currentSlide]).find(`.slick-dots li.slick-active`).removeClass('slick-active');
				$(slick.$slides[currentSlide]).find(`.slick-dots li.slick--active`).removeClass('slick--active');
				$(slick.$slides[currentSlide]).find(`.slick-dots li:nth-child(${currentSlide+1})`).addClass('slick--active');
			});
			$('#dp-slider').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				fade: true,
				cssEase: 'linear',
				slide: '.dp_item',
				speed: 500,
				arrows: false,
				// prevArrow: $('#dp-slider .slick--prev'),
				// nextArrow: $('#dp-slider .slick--next'),
				dots: true,
			    customPaging : function(slider, i) {
			        return `<span class="dot"><span class="sr-only">${i}</span></span>`;
			    },
			    // appendArrows: $('.slickActions'),
			    appendDots: $('.slickActions'),
				responsive: [
				    {
				        breakpoint: 1024,
				        settings: { slidesToShow: 1 }
				    },
				    {
				        breakpoint: 1023,
				        settings: "unslick"
				    }
				]
			});
			stackSliderDesktopEvents();
			// Add class to show the new result
			stackSliderStopAnimation();
			return;
		}
		if($("#historySlider").hasClass('init')) return;
		$("#historySlider").removeClass('open');
		reorderStackSlidesMobile();
		// Add class to show the new result
		stackSliderStopAnimation();
	}

	function stackSliderDesktopEvents() {
		$('.slickActions .slickArrow').on('click', function(e) {
			if($(this).hasClass('slickArrow--next')) {
				$('#dp-slider').slick("slickNext");
				return;
			}
			$('#dp-slider').slick("slickPrev");
		});
	}
/* Custom Widget - Fade Slider / Stack Slider */

/* Blog Article - Arrow Down */
	window.addEventListener('DOMContentLoaded', arrowScrollDown);
	function arrowScrollDown() {
		if(!document.querySelector('.bottom-arrow')) return;
		document.querySelector('.bottom-arrow').addEventListener('click', e => {
			const windowCoords = document.documentElement.clientHeight - document.querySelector('.Header').offsetHeight + 6;
			(function scroll() {
			  if (window.pageYOffset < windowCoords) {
			    window.scrollBy(0, 10);
			    setTimeout(scroll, 0);
			  }
			  if (window.pageYOffset > windowCoords) {
			    window.scrollTo(0, windowCoords);
			  }
			})();
		});
	}
/* Blog Article - Arrow Down */

/* Product Page - Custom Variant */
	window.addEventListener('DOMContentLoaded', pdpVariants);
	function getAbsoluteHeight(el) {
		const styles = window.getComputedStyle(el),
			margin = parseFloat(styles['marginTop']) + parseFloat(styles['marginBottom']);
		return Math.ceil(el.offsetHeight + margin);
	}
	function pdpVariantCalcHeight() {
		const d = getAbsoluteHeight(document.querySelector('.color-variant--item'));
		document.querySelector('.color-variant--wrapper .inner-wrapper').style.height = `${d}px`;
		return d;
	}
	function pdpVariantInitialHeight() {
		document.querySelector('.color-variant--wrapper .inner-wrapper').removeAttribute("style");
		setTimeout(() => pdpVariantCalcHeight(), 1000);
	}
	function pdpVariantsStartAnimation() {
		document.querySelector('.product__selectors').classList.remove('loaded');
	}

	function pdpVariantsStopAnimation() {
		setTimeout(() => document.querySelector('.product__selectors').classList.add('loaded'), 1000);
	}
	function pdpVariantsResizeHandler() {
		if(!document.querySelector('.trigger-extra-variants') || document.querySelector('.color-variant--wrapper .inner-wrapper').classList.contains('show-all-variants')) {
			document.querySelector('.color-variant--wrapper .inner-wrapper').removeAttribute("style");
			document.querySelector('.color-variant--wrapper .inner-wrapper').style.height = 'auto';
			pdpVariantsStopAnimation();
			return;
		}
		// Add class to hide and load
		pdpVariantsStartAnimation();
		pdpVariantInitialHeight();
		// Add class to show the new result
		pdpVariantsStopAnimation();
	}
  function pdpVariantsChangeVariant() {
    if(!document.querySelector('.color-variant--item')) return;
    document.querySelectorAll('.color-variant--item').forEach(el => {
      el.addEventListener('click', e => {
        if(el.classList.contains('active') || el.classList.contains('trigger-extra-variants')) return;
        document.querySelector('.color-variant--item.active').classList.remove('active');
        const curr_val = el.dataset.currentValue,
          curr_default_val = el.dataset.currentDefaultValue;
        el.classList.add('active');
        //document.querySelector('.color-variant--wrapper .val').textContent = curr_val;
        _cSc(document.querySelector(`.Popover[data-id="variantPopover"] [data-value="${curr_default_val}"]`));
      })
    });
  }
	function pdpVariants() {
		if(!document.querySelector('.product__selectors')) return;
		pdpVariantsChangeVariant();
    pdpVariantsResizeHandler();
		window.addEventListener('orientationchange', pdpVariantsResizeHandler);
		if(!document.querySelector('.trigger-extra-variants')) return;
		document.querySelectorAll('.trigger-extra-variants').forEach(el => {
			el.addEventListener('click', e => {
				if(e.currentTarget.matches('.triggered') || !e.isTrusted) return;
				const d = pdpVariantCalcHeight(),
					variants_total = parseInt(e.currentTarget.closest('.product__selectors').dataset.variants),
					variants_to_show = parseInt(e.currentTarget.querySelector('.lbl').textContent) - 1;
				let final_height;
				if(window.innerWidth >= 1024) {
					switch(variants_to_show){case 1:case 2:case 3:case 4:case 5:final_height=d*2;break;case 6:case 7:case 8:case 9:case 10:final_height=d*3;break;case 11:case 12:case 13:case 14:case 15:final_height=d*4;break;case 16:case 17:case 18:case 19:case 20:final_height=d*5;break;default:final_height=d}
				} else {
					switch(variants_to_show){case 1:case 2:case 3:case 4:final_height=d*2;break;case 5:case 6:case 7:case 8:final_height=d*3;break;case 9:case 10:case 11:case 12:final_height=d*4;break;case 13:case 14:case 15:case 16:final_height=d*5;break;case 17:case 18:case 19:case 20:final_height=d*6;break;default:final_height=d}
				}
				e.currentTarget.closest('.product__selectors').querySelector('.inner-wrapper').style.height = `${final_height}px`;
				e.currentTarget.classList.add('triggered');
				if(document.querySelector('.trigger-extra-variants:not(.triggered)')) document.querySelector('.trigger-extra-variants:not(.triggered)').classList.add('triggered');
				e.currentTarget.closest('.product__selectors').querySelector('.inner-wrapper').classList.add('show-all-variants');
			});
		})
	}
/* Product Page - Custom Variant */

/* Custom Widget - Product Page - Leather Care */
	window.addEventListener('DOMContentLoaded', pdpVideoOverlay);
	function pdpVideoOverlay() {
		if (window.jQuery && jQuery('.js-video__play')) {
			jQuery('.shopify-section--pdp_video_overlay .js-video__play').each(function() {
				$(this).magnificPopup({
					closeMarkup: '<button title="%title%" type="button" class="mfp-close"></button>',
					type: 'iframe',
					mainClass: 'mfp-fade',
					removalDelay: 160,
					preloader: false,
					fixedContentPos: false,
					iframe: {
						markup: '<div class="mfp-iframe-scaler">'+
							'<div class="mfp-close"></div>'+
							'<iframe class="mfp-iframe" frameborder="0" allow="autoplay" allowfullscreen></iframe>'+
							'</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
						patterns: {
							youtube: {
							index: 'youtube.com/',
								id: function(url) {
									var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
									var match = url.match(regExp);
									return (match&&match[7].length==11)? match[7] : false;
								},
								src: '//www.youtube.com/embed/%id%?autoplay=1'
							},
							vimeo: {
								index: 'vimeo.com/',
								id: function(url) {
									var m = url.match(/(https?:\/\/)?(www.)?(player.)?vimeo.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/);
									if ( !m || !m[5] ) return null;
									return m[5];
								},
								src: '//player.vimeo.com/video/%id%?autoplay=1'
							}
						},
						srcAction: 'iframe_src' // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
					},
					callbacks: {
						beforeOpen: function() {
							console.log('Start of popup initialization');
						},
					    open: function() {
					    	const triggerEl = this.ev[0];
					    	// getBckVideoIndex(triggerEl,'pause');
					    	triggerEl.closest('.shopify-section--pdp_video_overlay').querySelector('.js-video__play--trigger').classList.add('playing');
							// Will fire when this exact popup is opened
							// this - is Magnific Popup object
					    },
					    beforeClose: function() {
							// Callback available since v0.9.0
							console.log('Popup close has been initiated');
						},
					    close: function() {
					    	const triggerEl = this.ev[0];
					    	// getBckVideoIndex(triggerEl,'play');
					    	triggerEl.closest('.shopify-section--pdp_video_overlay').querySelector('.js-video__play--trigger').classList.remove('playing');
							// Will fire when popup is closed
					    },
					    afterClose: function() {
							console.log('Popup is completely closed');
						}
					  }
				});
			});
		}
	}
	// function getBckVideoIndex(el,action) {
	// 	const parent = el.closest('.shopify-section--bspok_video_on_video'),
	// 		frameId = parent.querySelector('.video__iframe.loaded iframe');
	// 	if(!frameId) return;
	// 	const _id = frameId.id;
	// 	let v;
	// 	for(const property in ytPlayers) {
	// 		if((ytPlayers[property].h.id == _id)) v = _id;
	// 	}
	// 	if(!v) return;
	// 	if(action == 'pause') {
	// 		ytPlayers[v].pauseVideo();
	// 		return;
	// 	}
	// 	ytPlayers[v].playVideo();
	// }
/* Custom Widget - Product Page - Leather Care */

/* Custom Listing */
	function closeDrawer() {
	    _cSc(document.querySelector('#usf-collection-filter-drawer .Drawer__Close'));
	}

	function customFiltersEvents(el) {
		if(!el) return;
		el.addEventListener('click', e => {
			if(!e.target.matches('.Popover__Value') || e.target.matches('.Popover__Value.is-selected') || !e.isTrusted) return;
			el.querySelector('.is-selected').classList.remove('is-selected');
			e.target.classList.add('is-selected');
			// closeDrawer();
			_cSc(document.querySelector(`#collection-sort-popoverv2 .Popover__Value[data-order-value="${e.target.dataset.orderValue}"]`));
      e.target.closest('.column-info-tab').querySelector('.column-title .val').textContent = `(${e.target.textContent})`;
			_ssc = !0;
			setTimeout(() => _ssc = !1, 1000);
		});
    if(!el.querySelector('.open-toggle > .column-title')) return;
    el.querySelector('.open-toggle > .column-title').addEventListener('click', handleCustomAccorion);
    if(el.querySelector('.open-toggle > .column-title').nextElementSibling.matches('.active')) el.querySelector('.open-toggle > .column-title').nextElementSibling.style.height = `${el.querySelector('.open-toggle > .column-title').nextElementSibling.offsetHeight}px`;
	}

	function applyFiltersEvents(el) {
		if(!el) return;
		el.addEventListener('click', e => closeDrawer());
	}

	// function clearFiltersEvents(els) {
	// 	if(!els.length) return;
	// 	els.forEach(el => {
	// 		el.addEventListener('click', e => {
	// 			if(!document.querySelector('#custom-usf-fk-sort .Popover__Value[data-order-value="r"]')) return;
	// 			_cSc(document.querySelector('#custom-usf-fk-sort .Popover__Value[data-order-value="r"]'));
	// 		});
	// 	});
	// }

	function customFiltersCount() {
		if(document.querySelector('.custom-item-count') && document.querySelector('#usf-sr-summary-temp') && document.querySelector('#usf-sr-summary-temp')) {
      document.querySelector('.custom-item-count').innerHTML = `${document.querySelector('#usf-sr-summary-temp > *').textContent} ${_cil}`;
      // console.log('count: ',document.querySelector('#usf-sr-summary-temp > *').textContent);
    }
	}

  // function getThumbMappedUrl(code) {
  //   if(!_ccjs || !_ccjs.code) return false;
  //   return _ccjs.code;
  // }

  function moveBreadcrumbs() {
    // debugger;
    if(document.querySelector('.CollectionToolbar .breadcrumb') || !(document.querySelector('.breadcrumb')) || !('[data-section-type="collection"] > .breadcrumb') || document.body.classList.contains('template-search')) return;
    const fragment = document.createDocumentFragment();
    fragment.appendChild(document.querySelector('.breadcrumb'));
    document.querySelector('.CollectionToolbar').appendChild(fragment);
    document.querySelector('.CollectionToolbar .breadcrumb').classList.add('visible');
  }

  function moveTotSearch() {
    if(!document.body.classList.contains('template-search') || !document.querySelector('#usf-sr-summary-temp') || document.querySelector('.CollectionToolbar #usf-sr-summary-temp')  || !document.documentElement.classList.contains('desktop')) return;
    const fragment = document.createDocumentFragment();
    document.querySelector('.CollectionToolbar').insertAdjacentHTML('beforeend','<div class="search-result-wrapper"></div>');
    fragment.appendChild(document.querySelector('#usf-sr-summary-temp'));
    document.querySelector('.CollectionToolbar .search-result-wrapper').appendChild(fragment);
    document.querySelector('.search-result-wrapper #usf-sr-summary-temp').classList.add('visible');
  }

  function renderCampaignImg() {
    const _f = document.createRange().createContextualFragment(_campaign_img),
      _o = window.innerWidth < 1024 ? 7 : 3; // 7 : 12
    if(document.querySelector('#usf_container .usf-results').children[_o]) document.querySelector('#usf_container .usf-results').children[_o].after(_f);
  }

  function customStickyEventsToolbar() {
    var observer = new IntersectionObserver(function(entries) {
      if(entries[0].intersectionRatio === 0 && document.querySelector(".CollectionToolbar--top"))
        document.querySelector(".CollectionToolbar--top").classList.add("shadow");
      else if(entries[0].intersectionRatio === 1 && document.querySelector(".CollectionToolbar--top"))
        document.querySelector(".CollectionToolbar--top").classList.remove("shadow");
    }, { threshold: [0,1] });

    observer.observe(document.querySelector(".SectionHeader__Heading"));
  }

	function createFkApplyBtnFilters() {
		if(document.querySelector('.custom-usf-apply') || !document.querySelector('#usf-sf-filter-tree .usf-refineby')) return;
		const _ih = `<div class="custom-usf-apply"><span id="btn-apply-filter">${_afl}</span></div>`;
		document.querySelector('#usf-sf-filter-tree .usf-refineby').insertAdjacentHTML('beforeend',_ih);
		applyFiltersEvents(document.querySelector('#btn-apply-filter'));
		// clearFiltersEvents(document.querySelectorAll('.usf-refineby .usf-clear-all'));
	}

  function creteFkActionsFilters() {
    if(document.querySelector('#usf-collection-filter-drawer .action--cln')) return;
    const el = document.querySelector('#usf-sf-filter-tree .usf-refineby'),
      cln = el.cloneNode(true);
    cln.classList.add('action--cln');
    document.querySelector('#usf-collection-filter-drawer .Drawer__Content').appendChild(cln);
    document.querySelector('.action--cln .usf-clear-all').addEventListener('click', e => _cSc(document.querySelector('#usf-sf-filter-tree .usf-refineby .usf-clear .usf-clear-all')));
    document.querySelector('.action--cln #btn-apply-filter').addEventListener('click', e => _cSc(document.querySelector('#usf-sf-filter-tree .usf-refineby .custom-usf-apply #btn-apply-filter')));
  }

	function customfiltersDesktopScroll() {
		console.log('filter case');
		// document.documentElement.style.setProperty('--scroll-giftbox-before-pos', '-65px');
		if(matchMedia('(hover: hover), (pointer: fine)').matches) {
		  if(!Scrollbar.has(document.querySelector('#usf-collection-filter-drawer .usf-facets__body'))) {
		    FilterDrawer = Scrollbar.init(document.querySelector('#usf-collection-filter-drawer .usf-facets__body'));
		    // GiftboxDrawer.addListener(function(e){
		    //   if(e.offset.y >= 0 && e.offset.y <= 65) document.documentElement.style.setProperty('--scroll-giftbox-before-pos', `${-65 + e.offset.y}px`);
		    // });
		  }
		} else { // Mobile Touch
		}
	}

	 function slideUp(target, duration=500){
		let display = window.getComputedStyle(target).display;
		if(display == 'none') return;
	    target.style.transitionProperty = 'height, margin, padding';
	    target.style.transitionDuration = duration + 'ms';
	    target.style.boxSizing = 'border-box';
	    target.style.height = target.offsetHeight + 'px';
	    target.offsetHeight;
	    target.style.overflow = 'hidden';
	    target.style.height = 0;
	    target.style.paddingTop = 0;
	    target.style.paddingBottom = 0;
	    target.style.marginTop = 0;
	    target.style.marginBottom = 0;
	    window.setTimeout(() => {
	      target.style.display = 'none';
	      target.style.removeProperty('height');
	      target.style.removeProperty('padding-top');
	      target.style.removeProperty('padding-bottom');
	      target.style.removeProperty('margin-top');
	      target.style.removeProperty('margin-bottom');
	      target.style.removeProperty('overflow');
	      target.style.removeProperty('transition-duration');
	      target.style.removeProperty('transition-property');
	    }, duration);
	};

	 function slideDown(target, duration=500){
	    const display = window.getComputedStyle(target).display;
		if(display !== 'none') return;
	    target.style.removeProperty('display');
	    target.style.display = 'block';
	    let height = target.offsetHeight;
	    target.style.overflow = 'hidden';
	    target.style.height = 0;
	    target.style.paddingTop = 0;
	    target.style.paddingBottom = 0;
	    target.style.marginTop = 0;
	    target.style.marginBottom = 0;
	    target.offsetHeight;
	    target.style.boxSizing = 'border-box';
	    target.style.transitionProperty = "height, margin, padding";
	    target.style.transitionDuration = duration + 'ms';
	    target.style.height = height + 'px';
	    target.style.removeProperty('padding-top');
	    target.style.removeProperty('padding-bottom');
	    target.style.removeProperty('margin-top');
	    target.style.removeProperty('margin-bottom');
	    window.setTimeout(() => {
	      target.style.removeProperty('height');
	      target.style.removeProperty('overflow');
	      target.style.removeProperty('transition-duration');
	      target.style.removeProperty('transition-property');
	    }, duration);
	};

	function slideToggle(target, duration = 400){
		if(window.getComputedStyle(target).display === 'none') {
			target.closest('.usf-facet').classList.remove('usf-collapsed');
			return this.slideDown(target, duration);
		} else {
			target.closest('.usf-facet').classList.add('usf-collapsed');
			return this.slideUp(target, duration);
		}
	}

	// window.addEventListener('DOMContentLoaded', customFilters);
	// function customFilters() {
	// 	if(!document.querySelector('#usf_container')) return;

	// 	if(document.querySelector('.Popover__ValueList')) {
	// 		const _ih = `<div id="custom-usf-fk-sort">${document.querySelector('.Popover__ValueList').innerHTML}</div>`;
	// 		if(document.querySelector('#usf-collection-filter-drawer')) {
	// 			document.querySelector('#usf-collection-filter-drawer .Drawer__Main').insertAdjacentHTML('beforeend',_ih);
	// 			customFiltersEvents(document.querySelector('#custom-usf-fk-sort'));
	// 		}
	// 	}
	// }
/* Custom Listing */

/* Textarea Count */
  window.addEventListener('DOMContentLoaded', textareaCount);
  var _lpic;
  function textareaCount() {
    document.querySelectorAll('.textareaJsCount').forEach(el => {
      el.addEventListener('keyup', e => {
        e.currentTarget.closest('.textareaJsCountWrapper').nextElementSibling.querySelector('.val').textContent = parseInt(e.currentTarget.getAttribute('maxlength')) - e.currentTarget.value.length;
        if(e.currentTarget.closest('#sidebar-giftmessage')) {
          checkForInvalidChars(document.querySelector('#customCartNote'),e.currentTarget.value);
          document.querySelector('#customGiftMessage').checked = e.currentTarget.value ? true : false;
        }
        if(document.querySelector('.Form__GiftMessage')) document.querySelector('.Form__GiftMessage .extra-label').textContent = e.currentTarget.value ? _cgmel : '';
      });
      if(!el.value) return;
      el.closest('.textareaJsCountWrapper').nextElementSibling.querySelector('.val').textContent = parseInt(el.getAttribute('maxlength')) - el.value.length;
    });
  }
  function checkForInvalidChars(el,s) { // Look for chinese, japanese and russian chars
    // const r = /[\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9f\u0400-\u04FF]/;
    // const r = /[^\x00-\x7F]/;
    const r = /[^\x00-\xFC]/;
    // if(s.match(r)) el.value = s.replace(/[^\x00-\x7F]/g, "");
    if(s.match(r)) {
      el.value = s.replace(/[^\x00-\xFC]/g, "");
      el.parentElement.querySelector('.error--chars').style.display = 'block';
      _lpic = Date.now();
      return true;
    }
    if(_lpic && Date.now()-_lpic>1000) el.parentElement.querySelector('.error--chars').style.display = 'none';
    // setTimeout(() => el.parentElement.querySelector('.error--chars').style.display = 'none', 2000);
    return true;
  }
  window.addEventListener('DOMContentLoaded', minicartCustomEvents);
  function minicartCustomEvents() {
    const sidebarCart = document.querySelector('#sidebar-cart');
    if(!sidebarCart) return;
    sidebarCart.addEventListener('keyup',minicartTextareaCount);
  }
  function minicartTextareaCount(event){
    if(!event.isTrusted || !event.target.matches('.minicartTextareaJsCount')) return;
    event.currentTarget.querySelector('.textareaCount .val').textContent = parseInt(event.target.getAttribute('maxlength')) - event.target.value.length;
    checkForInvalidChars(event.target,event.target.value);
    document.querySelector('#customGiftMessage').checked = event.target.value ? true : false;
    if(document.querySelector('.Form__GiftMessage')) document.querySelector('.Form__GiftMessage .extra-label').textContent = event.target.value ? _cgmel : '';
    if(!event.target) return;
    event.currentTarget.querySelector('.textareaCount .val').textContent = parseInt(event.target.getAttribute('maxlength')) - event.target.value.length;
  }
/* Textarea Count */

/* Floating Label for Select */
  window.addEventListener('DOMContentLoaded', formCustomStyle, {once:true});
  function formCustomStyle() {
    const els = document.querySelectorAll('form select');
    if(!els) return;
    adjustSelects(els);
  }
  function adjustSelects(els) {
    els.forEach(el => {
      el.parentNode.classList.add('custom-select-wrapper');
      const selectedOption = el.options[el.selectedIndex],
        _p = el.closest('.Form__Item');
      if(!_p) return;
      const lbl = _p.querySelector('label');
      if(!lbl || !el.options.length) return;
      lbl.classList.add('label--select');
      if(el.options[el.selectedIndex].value !== "") {
        lbl.classList.remove('label--select-hidden');
      } else {
        lbl.classList.add('label--select-hidden');
      }
      if(!selectedOption.textContent) {
        selectedOption.textContent = lbl.textContent;
      } else {
        el.add(new Option(lbl.textContent, '', true, true), el.options[0]);
      }
      el.addEventListener('change',handleSelectChange);
    });
  }
  function handleSelectChange(event) {
    if(!event.isTrusted) return;
    const lbl = this.closest('.Form__Item').querySelector('label');
    if(this.options[this.selectedIndex].value !== "") {
      lbl.classList.remove('label--select-hidden');
    } else {
      lbl.classList.add('label--select-hidden');
    }
  }
/* Floating Label for Select */

/* Bespoke Form */
  window.addEventListener('DOMContentLoaded', bespokeForm);
  function bespokeForm() {
    if(!document.querySelector('#bespokeSendRequest')) return;
    document.querySelector('#bespokeSendRequest').addEventListener('click',validateBespokeForm);
  }

  function validateBespokeForm() {
    const form = document.querySelector('#BespokeForm');
    if(!form.checkValidity()) {
      form.reportValidity();
      return;
    }
    if(form.querySelector('.bespoke-form-message')) form.querySelectorAll('.bespoke-form-message').forEach(m => m.remove());
    submitBespokeForm(form);
  }

  function submitBespokeForm(form) {

      form.closest('.Drawer').classList.add('loading');
      const url = 'https://contactmail.appshop.service.triboo.it/send-email';

      fetch(url,
          {
            method: 'POST',
            headers: {
              "Access-Control-Allow-Origin": "*"
            },
            mode: 'cors',
            cache: 'no-cache',
            body: new URLSearchParams(new FormData(form))
          })
          .then((response) => {
            if(response.ok) {
              const p = document.querySelector('#sidebar-bespoke'),
                i = p.querySelector('.text-wrapper');
              fadeOut(i.querySelector('.container'));
              fadeOut(p.querySelector('.Drawer__Footer'));
              i.insertAdjacentHTML('afterbegin',`<div class="bespoke-form-message bespoke-form-message--success">${_bfsm}</div>`);
              if(matchMedia('(hover: hover), (pointer: fine)').matches) {
                if(BespokeDrawer && Scrollbar.has(p.querySelector('.inner-wrapper'))) setTimeout(() => BespokeDrawer.setPosition(0,0), 250);
              } else {
                setTimeout(() => document.querySelector('#sidebar-bespoke .Drawer__Main').scrollTop = 0, 250);
              }
              return;
            }
            return Promise.reject(response);
          })
          .catch((error) => {
            if(matchMedia('(hover: hover), (pointer: fine)').matches) {
              if(BespokeDrawer && Scrollbar.has(document.querySelector('#sidebar-bespoke .inner-wrapper'))) setTimeout(() => BespokeDrawer.setPosition(0,0), 250);
            } else {
              setTimeout(() => document.querySelector('#sidebar-bespoke .Drawer__Main').scrollTop = 0, 250);
            }
            form.insertAdjacentHTML('afterbegin',`<div class="bespoke-form-message bespoke-form-message--error">${_bfem}</div>`);
            console.log('error');
          })
          .finally(() => {
            form.closest('.Drawer').classList.remove('loading');
          });

  }
/* Bespoke Form */

/* Embossing Form */
  window.addEventListener('DOMContentLoaded', embossingForm);
  function embossingForm() {
    embSidebar = document.querySelector('#sidebar-embossing');
    if(!embSidebar) return;
    if(embSidebar.querySelector('.type-js-wrapper')) embSidebar.querySelector('.type-js-wrapper').addEventListener('click',embSidebarType);
    if(embSidebar.querySelector('.inputs-js-wrapper input')) embSidebarLetters();
    if(embSidebar.querySelector('#clearEmbossing')) embSidebar.querySelector('#clearEmbossing').addEventListener('click',embossingClear);
    if(embSidebar.querySelector('#applyEmbossing')) embSidebar.querySelector('#applyEmbossing').addEventListener('click',embossingApply);
  }
  function embSidebarType(event) {
    if(!event.isTrusted || event.target.matches('.type.active,.type.active *') || (!(event.target.matches('.type,.type *')))) return;
    event.currentTarget.querySelector('.type.active').classList.remove('active');
    if(event.target.matches('.type')) {
      event.target.classList.add('active');
    } else {
      event.target.closest('.type').classList.add('active');
    }
    EmbossingSettings['color'] = event.currentTarget.querySelector('.type.active').dataset.val;
    embSidebar.querySelector('.image-js-wrapper').style.color = event.currentTarget.querySelector('.type.active').dataset.color;
  }
  function embSidebarLetters() {
    if(!embSidebar) return;
    embSidebar.querySelectorAll('.inputs-js-wrapper input').forEach(el => {
      el.addEventListener('keyup', event => {
        const index = event.target.dataset.index ? parseInt(event.target.dataset.index) : null;
        if(index === null) return;
        event.target.value = event.target.value.replace(/[^a-zA-Z0-9]+/g,"");
        if(!event.target.value) {
          event.target.classList.remove('active');
          if(!embSidebar.querySelector('#jsEmbossingText')) return;
          EmbossingSettings.txt = [...event.target.closest('.inputs-js-wrapper').querySelectorAll('input')].filter(el => el.value).reduce((acc,item)=> `${acc+item.value}${isNaN(parseInt(item.value)) ? '.' : ''}`,'');
          embSidebar.querySelector('#jsEmbossingText').textContent = EmbossingSettings.txt.toUpperCase();
          return;
        } else {
        //if(event.target.value) {
          event.target.classList.add('active');
          let focusToNext = !0;
          switch(event.code) {
            case "Tab":
              focusToNext = !1;
              break;
            case "ShiftLeft":
              focusToNext = !1;
              break;
            case "ShiftRight":
              focusToNext = !1;
              break;
            default:
              focusToNext = !0;
          }
          if(index !== 2 && focusToNext) {
            console.log("event.code",event.code);
            console.log("event.code - v4",event.code !== 'Tab');
            // event.target.closest('.inputs-js-wrapper').querySelector(`input[data-index="${index+1}"]`).removeAttribute('disabled');
            event.target.closest('.inputs-js-wrapper').querySelector(`input[data-index="${index+1}"]`).focus();
          } else {
            console.log("event.code",event.code);
            console.log("event.code - v4.1",event.code !== 'Tab');
            //return;
          }
        } /*else {
            event.target.classList.remove('active');
            // switch(index) {
            //   case 0:
            //     event.target.closest('.inputs-js-wrapper').querySelector('input[data-index="1"]').classList.remove('active');
            //     event.target.closest('.inputs-js-wrapper').querySelector('input[data-index="1"]').disabled = true;
            //     event.target.closest('.inputs-js-wrapper').querySelector('input[data-index="1"]').value = '';
            //     event.target.closest('.inputs-js-wrapper').querySelector('input[data-index="2"]').classList.remove('active');
            //     event.target.closest('.inputs-js-wrapper').querySelector('input[data-index="2"]').disabled = true;
            //     event.target.closest('.inputs-js-wrapper').querySelector('input[data-index="2"]').value = '';
            //   case 1:
            //     event.target.closest('.inputs-js-wrapper').querySelector('input[data-index="2"]').disabled = true;
            //   event.target.closest('.inputs-js-wrapper').querySelector('input[data-index="2"]').value = '';
            //   default:
            //     console.log('case 3');
            // }
          }*/
          if(!embSidebar.querySelector('#jsEmbossingText')) return;
          EmbossingSettings.txt = [...event.target.closest('.inputs-js-wrapper').querySelectorAll('input')].filter(el => el.value).reduce((acc,item)=> `${acc+item.value}${isNaN(parseInt(item.value)) ? '.' : ''}`,'');
          embSidebar.querySelector('#jsEmbossingText').textContent = EmbossingSettings.txt.toUpperCase();
      });
    });
  }
  function embossingClear(event) {
    if(!event.isTrusted) return;
    embSidebar.querySelectorAll('.inputs-js-wrapper input').forEach(el => {
      el.classList.remove('active');
      el.value = '';
    });
    embSidebar.querySelector('#jsEmbossingText').textContent = '';
    EmbossingSettings['color'] = 'silver';
    EmbossingSettings['txt'] = '';
    embSidebar.querySelector('.inputs-js-wrapper input[data-index="0"]').focus();
    if(embSidebar.querySelector('.type.active').dataset.val === 'silver') return;
    embSidebar.querySelector('.type.active').classList.remove('active');
    embSidebar.querySelector('.type[data-val="silver"]').classList.add('active');
    embSidebar.querySelector('.image-js-wrapper').style.color = null;
  }
  function embossingApply(event) {
    if(!event.isTrusted) return;
    _cSc(document.querySelector('#sidebar-embossing .Drawer__Close'));
    _cSc(document.querySelector('.ProductForm__BuyButtons .ProductForm__AddToCart[data-action="add-to-cart"]'));
  }
/* Embossing Form */

/* California Privacy Rights Act */
window.addEventListener('DOMContentLoaded', modalInfoCaliPrivacy);
function modalInfoCaliPrivacy() {
	const btnInfoCaliPrivacy = document.querySelector(".CaliforniaRightsCustomForm__List > ul > li > p > strong");
	if(!btnInfoCaliPrivacy) return;
	btnInfoCaliPrivacy.addEventListener('click', openModalInfoCaliPrivacy);
}
function openModalInfoCaliPrivacy() {
	document.querySelector('.PageOverlay').classList.add('is-visible');
	document.getElementById("modalInfoCaliPrivacy").style.display = "flex";
	const ctaInfoCaliPrivacy = document.querySelector("#modalInfoCaliPrivacy .CaliforniaRights__modal--cta");
	if(!ctaInfoCaliPrivacy) return;
	ctaInfoCaliPrivacy.addEventListener('click', closeModalInfoCaliPrivacy);
	if(!document.querySelector('.PageOverlay')) return;
	document.querySelector('.PageOverlay').addEventListener('click', closeModalInfoCaliPrivacy);
}
function closeModalInfoCaliPrivacy() {
	document.querySelector('.PageOverlay').classList.remove('is-visible');
	document.getElementById("modalInfoCaliPrivacy").style.display = "none";
}

window.addEventListener('DOMContentLoaded', submitInfoCaliPrivacy);
function submitInfoCaliPrivacy() {
	const submitBtnCaliPrivacy = document.querySelector("#californiaRightsFormSubmit");
	if(!submitBtnCaliPrivacy) return;
	submitBtnCaliPrivacy.addEventListener('click', validateCaliFormCustom);
}
function checkNameCaliForm(event) {
	var e = event;
	let isNameOk = true;
	document.querySelectorAll('#CaliforniaRightsCustomForm input[name=first_name]').forEach(function(el) {
		if(!el.value) {
				el.closest('.CaliforniaRightsCustomForm__Item').classList.add("error");
				e.preventDefault();
				e.cancelBubble = true;
				e.stopImmediatePropagation();
				e.stopPropagation();
				isNameOk = false;
		} else {
				el.closest('.CaliforniaRightsCustomForm__Item').classList.remove("error");
		}
	});
	return isNameOk;
}
function checkLastNameCaliForm(event) {
	var e = event;
	let isLastNameOk = true;
	document.querySelectorAll('#CaliforniaRightsCustomForm input[name=last_name]').forEach(function(el) {
		if(!el.value) {
				el.closest('.CaliforniaRightsCustomForm__Item').classList.add("error");
				e.preventDefault();
				e.cancelBubble = true;
				e.stopImmediatePropagation();
				e.stopPropagation();
				isLastNameOk = false;
		} else {
				el.closest('.CaliforniaRightsCustomForm__Item').classList.remove("error");
		}
	});
	return isLastNameOk;
}
function checkEmailCaliForm(event) {
	var e = event;
	let isEmailOk = true;
	document.querySelectorAll('#CaliforniaRightsCustomForm input[type=email]').forEach(function(el) {
		const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if(!el.value.match(regex)) {
				el.closest('.CaliforniaRightsCustomForm__Item').classList.add("error");
				e.preventDefault();
				e.cancelBubble = true;
				e.stopImmediatePropagation();
				e.stopPropagation();
				isEmailOk = false;
		} else {
				el.closest('.CaliforniaRightsCustomForm__Item').classList.remove("error");
		}
	});
	return isEmailOk;
}
function checkCheckboxCaliForm(event) {
	var e = event;
	let isChecked = true;
	document.querySelectorAll('#CaliforniaRightsCustomForm .input-checkbox#californiaRightsCustomFormPrivacy').forEach(function(el) {
		if(!el.checked) {
			el.closest('.Form__Item').classList.add("error");
			e.preventDefault();
			e.cancelBubble = true;
			e.stopImmediatePropagation();
			e.stopPropagation();
			isChecked = false;
		} else {
			el.closest('.Form__Item').classList.remove("error");
		}
	});
	return isChecked;
}
function checkRecaptcha() {
  var response = grecaptcha.getResponse();
	let isRecaptchaOk = true;
  if(response.length == 0) {
		document.querySelector('#CaliforniaRightsCustomForm .g-recaptcha-error').style.display = "block";
		isRecaptchaOk = false;
  } else {
		document.querySelector('#CaliforniaRightsCustomForm .g-recaptcha-error').style.display = "none";
	}
  return isRecaptchaOk;
}
function validateCaliFormCustom(event) {
	let nameOk = checkNameCaliForm(event);
	let lastNameOk = checkLastNameCaliForm(event);
	let emailOk = checkEmailCaliForm(event);
	let checkboxOk = checkCheckboxCaliForm(event);
	let recaptchaOk = checkRecaptcha();
	if(nameOk && lastNameOk && emailOk && checkboxOk && recaptchaOk){
		const form = document.querySelector('#CaliforniaRightsCustomForm');
		if (!form.checkValidity()) {
			form.reportValidity();
			return;
		}
		openModalSubmitInfoCaliPrivacy();
	}
}
function openModalSubmitInfoCaliPrivacy() {
	document.querySelector('.PageOverlay').classList.add('is-visible');
	document.getElementById("modalConfirmCaliPrivacy").style.display = "flex";
	const cancelBtnFormCaliPrivacy = document.querySelector("#modalConfirmCaliPrivacy .CaliforniaRights__modal--primary-btn");
	const confirmBtnFormCaliPrivacy = document.querySelector("#modalConfirmCaliPrivacy .CaliforniaRights__modal--secondary-btn");
	if(cancelBtnFormCaliPrivacy) cancelBtnFormCaliPrivacy.addEventListener('click', closeModalSubmitInfoCaliPrivacy);
	if(confirmBtnFormCaliPrivacy) confirmBtnFormCaliPrivacy.addEventListener('click', submitFormCaliPrivacy);
	document.querySelector('.PageOverlay').addEventListener('click', event.preventDefault());
}
function closeModalSubmitInfoCaliPrivacy() {
	document.querySelector('.PageOverlay').classList.remove('is-visible');
	document.getElementById("modalConfirmCaliPrivacy").style.display = "none";
}
function submitFormCaliPrivacy() {
	closeModalSubmitInfoCaliPrivacy();
	const form = document.querySelector('#CaliforniaRightsCustomForm');
	const url = 'https://serapian.appshop.service.triboo.it/api/cpra';
	const formData = new FormData(form);
	var data = {
		"name": formData.get("first_name"),
		"surname": formData.get("last_name"),
		"email": formData.get("email_address")
	};
	var xhr = new XMLHttpRequest();
	xhr.open('POST', url, true);
	xhr.setRequestHeader('Content-Type', 'application/json');
	xhr.onload = function() {
		if (xhr.status === 200) {
			document.querySelector('.PageOverlay').classList.add('is-visible');
			document.getElementById("modalSuccessCaliPrivacy").style.display = "block";
			const closeIcon = document.getElementById("closeSuccessModal");
			if(!closeIcon) return;
			closeIcon.addEventListener('click', closeModalSuccessCaliPrivacy);
			if(!document.querySelector('.PageOverlay')) return;
			document.querySelector('.PageOverlay').addEventListener('click', closeModalSuccessCaliPrivacy);
		} else {
			removePreviousMessage();
			form.insertAdjacentHTML('beforebegin',`<div class="ContactFormCustom-form-message ContactFormCustom-form-message--error">${_californiaRightsFormCustom_err_mess}</div>`);
			scrollToSeeMessage();
			console.error('Error: ', xhr.status);
		}
	};
	xhr.send(JSON.stringify(data));
}
function closeModalSuccessCaliPrivacy() {
	document.querySelector('.PageOverlay').classList.remove('is-visible');
	document.getElementById("modalSuccessCaliPrivacy").style.display = "none";
	location.reload();
}
function removePreviousMessage() {
	if(document.querySelector('.ContactFormCustom-form-message')) document.querySelector('.ContactFormCustom-form-message').remove();
}
function scrollToSeeMessage() {
	let message = document.querySelector('.ContactFormCustom-form-message');
	if(!message) return;
	let messageOffsetTop = message.offsetTop - (window.innerHeight / 2);
	window.scrollTo({
		top: messageOffsetTop,
		left: 0,
		behavior: "smooth",
	});
}
/* California Privacy Rights Act */

/* Contact Form Custom */
window.addEventListener('DOMContentLoaded', contactFormCustom);

function contactFormCustom() {
	if(!document.querySelector('#contactFormCustomSendRequest')) return;
	document.querySelector('#contactFormCustomSendRequest').addEventListener('click', validateContactFormCustom);
}

function checkCheckbox(event) {
	var e = event;
	let isChecked = true;
	document.querySelectorAll('#ContactFormCustomForm .input-checkbox#contactFormCustomPrivacy').forEach(function(el) {
		if(!el.checked) {
			el.closest('.Form__Item').classList.add("error");
			e.preventDefault();
			e.cancelBubble = true;
			e.stopImmediatePropagation();
			e.stopPropagation();
			isChecked = false;
		} else {
			el.closest('.Form__Item').classList.remove("error");
		}
	});
	return isChecked;
}

function checkTelNumber(event) {
	var e = event;
	let isTelNumberOk = true;
	document.querySelectorAll('#ContactFormCustomForm input[type=tel]').forEach(function(el) {
		el.value = el.value.replaceAll(' ', '')
		const regex = /^[0-9]+$/;
		if(!el.value.match(regex) || el.value.length < 4) {
			el.closest('.Form__Item').classList.add("error");
			e.preventDefault();
			e.cancelBubble = true;
			e.stopImmediatePropagation();
			e.stopPropagation();
			isTelNumberOk = false;
		} else {
			el.closest('.Form__Item').classList.remove("error");
		}
	});
	return isTelNumberOk;
}

function validateContactFormCustom(event) {
	let checkboxOk = checkCheckbox(event);
	let telNumberOk = checkTelNumber(event);
	if(checkboxOk && telNumberOk){
		const form = document.querySelector('#ContactFormCustomForm');
		if (!form.checkValidity()) {
			form.reportValidity();
			return;
		}
		if (form.querySelector('.contactFormCustom-form-message')) form.querySelectorAll('.contactFormCustom-form-message').forEach(m => m.remove());
		submitContactFormCustom(form);
	}
}

function removePreviousMessage() {
	if(document.querySelector('.ContactFormCustom-form-message')) document.querySelector('.ContactFormCustom-form-message').remove();
}

function scrollToSeeMessage() {
	let message = document.querySelector('.ContactFormCustom-form-message')
	if(!message) return;
	let messageOffsetTop = message.offsetTop - (window.innerHeight / 2);
	window.scrollTo({
		top: messageOffsetTop,
		left: 0,
		behavior: "smooth",
	})
}

function submitContactFormCustom(form) {
	const url = 'https://serapian.appshop.service.triboo.it/api/contacts';
	fetch(url,
		{
			method: 'POST',
			headers: {
				"Access-Control-Allow-Origin": "*"
			},
			mode: 'cors',
			cache: 'no-cache',
			body: new URLSearchParams(new FormData(form))
		})
		.then((response) => response.json())
		.then((response) => {
			if(response.status) {
				const formSection = document.querySelector('.ContactFormCustom__section');
				if(!formSection) return;
				formSection.innerHTML = `<div class="ContactFormCustom-form-message ContactFormCustom-form-message--success">${_contactFormCustom_suc_mess}</div>`;
				scrollToSeeMessage();
				return;
			} else {
				removePreviousMessage();
				form.insertAdjacentHTML('beforebegin',`<div class="ContactFormCustom-form-message ContactFormCustom-form-message--error">${_contactFormCustom_err_mess}</div>`);
				scrollToSeeMessage();
			}
			return Promise.reject(response);
		})
		.catch((error) => {
			removePreviousMessage();
			form.insertAdjacentHTML('beforebegin',`<div class="ContactFormCustom-form-message ContactFormCustom-form-message--error">${_contactFormCustom_err_mess}</div>`);
			scrollToSeeMessage()
		})
		.finally(() => {
		});
}
/* Contact Form Custom */

/* Store Locator App Fixes */
  var storeLocatorScrollbarList;
  window.addEventListener('DOMContentLoaded', customStoreLocator);
  function customStoreLocator() {
    if(!document.querySelector('#addresses_list')) return;
    // if(document.querySelector('.search_filters')) {
    //   document.querySelector('.search_filters').insertAdjacentHTML('beforeend','<span class="search_filter"><input type="checkbox" id="search_filter_custom" name="search_filter_custom" checked="checked"> <label for="search_filter_custom">All Stores</label></span>');
    // }
    // if(document.querySelector('#address_search')) {
     document.querySelector('#address_search').value = '';
     document.querySelector('#address_search').placeholder = 'Insert Address';
    //}
    document.documentElement.style.setProperty('--scroll-storelocator-before-pos', '-65px');
    if(matchMedia('(hover: hover), (pointer: fine)').matches) {
      if(!Scrollbar.has(document.querySelector('#addresses_list'))) {
        storeLocatorScrollbarList = Scrollbar.init(document.querySelector('#addresses_list'));
        storeLocatorScrollbarList.addListener(function(e){
          if(e.offset.y >= 0 && e.offset.y <= 65) document.documentElement.style.setProperty('--scroll-storelocator-before-pos', `${-65 + e.offset.y}px`);
        });
      }
    } else { // Mobile Touch
      const el = document.querySelector('#addresses_list ul');
      let timer;
      el.addEventListener('scroll', e => {
        console.log('scroll',e.currentTarget.scrollTop);
        if(e.currentTarget.scrollTop >= 0 && e.currentTarget.scrollTop <= 65) document.documentElement.style.setProperty('--scroll-storelocator-before-pos', `${-65 + e.currentTarget.scrollTop}px`);
        const offset = e.currentTarget.scrollTop;
        if(timer !== null) clearTimeout(timer);
        timer = setTimeout(() => {
          if(offset === 0) document.documentElement.style.setProperty('--scroll-storelocator-before-pos', '-65px');
          if(offset > 65) document.documentElement.style.setProperty('--scroll-storelocator-before-pos', '0px');
        },150,offset);
      });
    }
	// sort first 4 locations onload:
	const oldList_ul = document.querySelector('#addresses_list ul');
	const oldList_length = document.querySelector('#addresses_list ul').childElementCount;
	let newList_li_nodes = [];
	let first_node; let second_node; let third_node; let fourth_node;
	for( let i = 0; i <= (oldList_length - 1); i++){
	  let this_node = oldList_ul.children[i];
	  let this_node_name = this_node.textContent.toLowerCase();
	  if(this_node_name.includes('serapian boutique milano')){
		  first_node = this_node;
	  } else if (this_node_name.includes('serapian boutique roma')){
		  second_node = this_node;
	  } else if (this_node_name.includes('la rinascente via santa radegonda')){
		  third_node = this_node;
	  } else if (this_node_name.includes('corso como')){
		  fourth_node = this_node;
	  } else {
		  newList_li_nodes.push(this_node);
	  }
	}
	newList_li_nodes.unshift(first_node, second_node, third_node, fourth_node)
	oldList_ul.textContent = '';
	for( let i = 0; i <= (oldList_length - 1); i++){
	  if (newList_li_nodes[i] !== undefined) oldList_ul.append(newList_li_nodes[i]);
	}
  }
  // function setCurrentPosition() {

  // }
/* Store Locator App Fixes */

/* Change Country */
  window.addEventListener('DOMContentLoaded', changeCountry);
  function changeCountry() {

    updateChangeLangURL();

    document.querySelector('#sidebar-country').addEventListener('transitionend', e => {
      if(e.currentTarget.classList.contains('full-size')) {
        e.currentTarget.classList.add('full-size--end');
      } else {
        e.currentTarget.classList.remove('full-size--end');
      }
    });

    if(document.querySelector('.change-country-trigger')) {
      document.querySelector('.change-country-trigger').addEventListener('click', e => {
        document.querySelector('#sidebar-country').classList.add('full-size');
        fadeOut(document.querySelector('.country-language-wrapper'));
        setTimeout(() => fadeIn(document.querySelector('.country-list-wrapper')), 400);
      });
    }

    if(document.querySelector('#sidebar-country .Drawer__Title--back')) {
      document.querySelector('#sidebar-country .Drawer__Title--back').addEventListener('click', e => {
        document.querySelector('#sidebar-country').classList.remove('full-size','full-size--end');
        fadeOut(document.querySelector('.country-list-wrapper'));
        setTimeout(() => fadeIn(document.querySelector('.country-language-wrapper')), 400);
      });
    }

    if(!document.documentElement.classList.contains('desktop')) return;
    document.querySelector('#sidebar-country .language-current-wrapper').addEventListener("mouseover", countryLanguageMenuDesktopEventsIn);
    document.querySelector('#sidebar-country .language-current-wrapper').addEventListener("mouseout", countryLanguageMenuDesktopEventsOut);
    document.querySelector('#sidebar-country .country-list-wrapper').addEventListener("mouseover", countryListMenuDesktopEventsIn);
    document.querySelector('#sidebar-country .country-list-wrapper').addEventListener("mouseout", countryListMenuDesktopEventsOut);
  }

  /* Update URL Chnge Languge */
  function updateChangeLangURL() {
    if(!(document.querySelector('.language-wrapper') && document.querySelector('.language-wrapper .language-val') && document.querySelector('.language-wrapper .language-val > a'))) return;
    document.querySelectorAll('.language-wrapper .language-val > a').forEach(l => {
      const urlSeparator = l.href.endsWith("/") ? "" : "/",
        keptParams = keepUrlParams();
        // debugger;
      let newUrl = l.href+urlSeparator+geo_prefix+geo_handle;
      if(keptParams) {
        for(const [key, value] of Object.entries(keptParams)) {
          newUrl = updateQueryStringParameter(newUrl,key,value);
        }
      }
	  // if cookies are not accepted and navigation continues fix l.href since this function gets called twice
	  let previousUrl = l.href;
	  if( ! previousUrl.includes(urlSeparator+geo_prefix+geo_handle) ){
	  	l.href = newUrl;
	  }
    });
  }
  /* Update URL Chnge Languge */

  /* Manage Country-Language Menu */
    function countryLanguageMenuDesktopEventsIn(event) {
      if(!event.isTrusted || !document.documentElement.classList.contains('desktop')) return;
      const target = event.target,
        isLinkEl = target.tagName.toLowerCase() === "a";
      if(isLinkEl) {
        target.classList.remove('half-opacity');
        target.classList.add('full-opacity');
        // Set opacity to all link in the other list
        if(target.closest('.language-current-wrapper .language-wrapper').children.length > 1) {
          const el = target.parentElement.parentElement;
          for (const sibling of el.querySelectorAll('li')) {
            const el = sibling.querySelector('a');
            if (el !== target) {
              el.classList.add('half-opacity');
              el.classList.remove('full-opacity','is-active');
            }
          }
        }
        // Set half-opacity to all link in the other list
      }
    }

    function countryLanguageMenuDesktopEventsOut(event) {
      if(!event.isTrusted || !document.documentElement.classList.contains('desktop') || !document.querySelector('#sidebar-country .language-current-wrapper a[data-active="true"]')) return;
      const _ct = event.currentTarget.querySelector('a[data-active="true"]');
      for (const sibling of event.currentTarget.querySelectorAll('li')) {
        const el = sibling.querySelector('a');
        if(el !== _ct) {
          el.classList.remove('half-opacity','full-opacity','is-active');
        } else {
          el.classList.remove('half-opacity','full-opacity');
          el.classList.add('is-active');
        }
      }
    }
  /* Manage Country-Language Menu */

  /* Manage Country List Menu */
    function countryListMenuDesktopEventsIn(event) {
      if(!event.isTrusted || !document.documentElement.classList.contains('desktop')) return;
      const target = event.target,
        isLinkEl = target.tagName.toLowerCase() === "span";
      if(isLinkEl) {
        target.classList.remove('half-opacity');
        target.classList.add('full-opacity');
        // Set opacity to all link in the other list
        if(target.closest('#sidebar-country .country-list-wrapper .SectionHeader__TabList').children.length > 1) {
          const el = target.parentElement.parentElement;
          for (const sibling of el.querySelectorAll('.Custom__TabList-Item')) {
            const el = sibling.querySelector('span');
            if (el !== target) {
              el.classList.add('half-opacity');
              el.classList.remove('full-opacity','is-active');
            }
          }
        }
        // Set half-opacity to all link in the other list
      }
    }

    function countryListMenuDesktopEventsOut(event) {
      // debugger;
      if(!event.isTrusted || !document.documentElement.classList.contains('desktop') || !document.querySelector('#sidebar-country .language-current-wrapper a[data-active="true"]')) return;
      const _ct = (event.currentTarget.querySelector('.Custom__TabList-Item.is-active span') === event.currentTarget.querySelector('span[data-active="true"]')) ? event.currentTarget.querySelector('span[data-active="true"]') : event.currentTarget.querySelector('.Custom__TabList-Item.is-active span');
      for (const sibling of event.currentTarget.querySelectorAll('.Custom__TabList-Item')) {
        const el = sibling.querySelector('span');
        if(el !== _ct) {
          el.classList.remove('half-opacity','full-opacity','is-active');
        } else {
          el.classList.remove('half-opacity','full-opacity');
          el.classList.add('is-active');
        }
      }
    }
  /* Manage Country List Menu */
/* Change Country */

/* Geolocator */
  window.addEventListener('DOMContentLoaded',customGeolocator);

  // OK
  var geolocatorClassesIds = {
    geolocatorWrapper: 'selectCountryWrapper',
    link: 'select-country-link'
  };

  //OK
  var geolocatorCache = {};

  //OK
  function customGeolocator() {
    // debugger;
    // const defaultDomain = 'https://www.serapian.com';
    // const isDefault = isDefaultDomain(defaultDomain);
	let text = window.location
	const pattern = /apps\/rma/;
	if(pattern.test(text)){
	  return false;
	}

    var crawlerAgentRegex = /bot|google|aolbuild|baidu|bing|msn|duckduckgo|teoma|slurp|yandex|facebook|yahoo/i;
    if (crawlerAgentRegex.test(navigator.userAgent)) {
        return false;
    }

    /* Language Management */
    const language = geolocatorGetCookie('geolocator_language');
    if(!current_lang) current_lang = 'en';
    if(!language) {
      geolocatorUpdateCookie('geolocator_language',current_lang,false);
    } else {
      if(language !== current_lang) geolocatorUpdateCookie('geolocator_language',current_lang,false);
    }
    /* Language Management */

    /* Slug lang-country Management */
    const slug = geolocatorGetCookie('geolocator_slug');
    if(!current_slug) current_slug = '/';
    if(!slug) {
      geolocatorUpdateCookie('geolocator_slug',current_slug,false);
    } else {
      if(slug !== current_slug) geolocatorUpdateCookie('geolocator_slug',current_slug,false);
    }
    /* Slug lang-country Management */

    const shopifyAdminDomain = '.myshopify.com/admin',
      noGeoParam = 'nogeo',
      isAdmin = isAdminPreview(shopifyAdminDomain),
      noGeo = urlParam(noGeoParam);

      if(!isAdmin && !noGeo) {
          geolocatorCacheSelectors();
          changeCountryEvents();

          /*
           * EU geo-blocking (Reg. 2018/302): no GeoIP auto-redirect without consent.
           * Sync cookie/UI to the current Shopify Markets localization on this page.
           * Suggested market switch is handled by Geos (popup + consent).
           */
          const marketCountry = (typeof current_market === 'string' && current_market)
            ? current_market
            : null;

          if (marketCountry) {
            geolocatorUpdateCookie('geolocator_country', marketCountry, false);
            _currCountry = marketCountry;
            syncGeolocatorUi(marketCountry);

            const check_cart = geolocatorGetCookie('check_cart');
            if (check_cart && check_cart === '1') return;
            geolocatorUpdateCookie('check_cart', '1', false);
            checkCart();
          }
      }
  }

  //OK
  function urlParam(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results==null) return null;
    return results[1] || 0;
  }

  //OK
  function keepUrlParams() {
    let res = {};
    const self = window.location.toString(),
      querystring = self.split("?");
    if(querystring.length > 1) {
      const pairs = querystring[1].split("&");
      for(i in pairs) {
        let keyval = pairs[i].split("=");
        //if(keyval[0].indexOf('utm_') > -1) res[keyval[0]] = decodeURIComponent(keyval[1]);
        res[keyval[0]] = decodeURIComponent(keyval[1]);
      }
    }
    return res;
  }

  //OK
  function updateQueryStringParameter(uri, key, value) {
    const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i"),
      separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if(uri.match(re)) return uri.replace(re, '$1' + key + "=" + value + '$2');
    return uri + separator + key + "=" + value;
  }

  //OK
  function isAdminPreview(shopifyAdminDomain) {
    if(window.parent.location.href.indexOf(shopifyAdminDomain) > -1) return true;
    return false;
  }

  /*
    function isDefaultDomain(defaultDomain) {
      if(defaultDomain == window.location.origin) {
          getIpCountry();
          return true;
      }
      return false;
    }
  */
  // UI-only sync for country selector (no redirect).
  function syncGeolocatorUi(countryIsoCode) {
    if (!countryIsoCode) return;

    let geolocatorLink = document.querySelector('.'+geolocatorClassesIds.link+'[data-country="'+countryIsoCode+'"]');
    if (geolocatorLink) {
      geolocatorLink.className = 'select-country-link select-country-link--active Link Link--underline';
      const _id = geolocatorLink.closest('.TabPanel') ? geolocatorLink.closest('.TabPanel').id : null;
      if (_id && document.querySelector(`#sidebar-country .Custom__TabList-Item[aria-controls="${_id}"]`)) {
        geolocatorLink.closest('.TabPanel').setAttribute('aria-hidden', false);
        document.querySelector(`#sidebar-country .Custom__TabList-Item[aria-controls="${_id}"]`).dataset.active = "true";
        document.querySelector(`#sidebar-country .Custom__TabList-Item[aria-controls="${_id}"]`).classList.add('is-active');
        document.querySelector(`#sidebar-country .Custom__TabList-Item[aria-controls="${_id}"]`).setAttribute('aria-selected', true);
        document.querySelector(`#sidebar-country .Custom__TabList-Item[aria-controls="${_id}"]`).querySelector('.Custom__TabList-InnerItem').classList.add('is-active');
        document.querySelector(`#sidebar-country .Custom__TabList-Item[aria-controls="${_id}"]`).querySelector('.Custom__TabList-InnerItem').dataset.active = "true";
      }
    }
    if (document.querySelector('.country-language-wrapper .country-current-val') && geolocatorLink) {
      document.querySelector('.country-language-wrapper .country-current-val').textContent = geolocatorLink.textContent;
    }
    if (document.querySelector('.country-selector-wrapper')) {
      document.querySelectorAll('.country-selector-wrapper').forEach(el => {
        const countryEl = el.querySelector('.country-selector--country');
        if (countryEl) countryEl.textContent = countryIsoCode;
      });
    }
  }

  /*
   * Disabled for EU geo-blocking compliance (Reg. 2018/302).
   * Previously: GeoIP lookup → cookie → hard redirect without consent.
   * Market suggestions must go through Geos popup + explicit consent.
   */
  function getIpCountry() {
    return;
  }

  // Forse da aggiungere cookie "location" di Shopify
  function geolocatorUpdateCookie(key,value,deleteCookie) {
    // debugger;
    // const domain = 'serapian.com';
    const domain = _staging ? 'serapian-shop-eu.myshopify.com' : 'serapian.com';
    let expires = '';
    if(deleteCookie) {
      let d = new Date;
      d.setTime(d.getTime() + 24*60*60*1000*-1);
      expires = `;expires=${d.toGMTString()}`;
    }
    document.cookie = `${key}=${value};path=/;domain=${domain}${expires}`;
  }

  // Forse da aggiungere cookie "location" di Shopify
  function geolocatorClearCookie(key) {
    geolocatorUpdateCookie(key,'',true)
  }

  function changeCountryEvents() {
    document.querySelectorAll(`.${geolocatorClassesIds.link}`).forEach(el => el.addEventListener('click', getLinkAttr));
    document.querySelectorAll('#sidebar-country .language-wrapper .language-val > a[data-language-code]').forEach(el => {
      el.addEventListener('click', getLanguageAttr);
    });
  }

  // Shopify Markets: country/language must go through /localization (not hard domain redirect)
  function shopifyLocalizationRedirect(fields) {
    const params = [
      {
        name: 'return_to',
        value: window.location.pathname + window.location.search + window.location.hash
      },
      { name: 'form_type', value: 'localization' },
      { name: '_method', value: 'put' }
    ];
    if (fields && fields.country_code) {
      params.push({ name: 'country_code', value: fields.country_code });
    }
    if (fields && fields.language_code) {
      params.push({ name: 'language_code', value: fields.language_code });
    }
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/localization';
    params.forEach(function(param) {
      const field = document.createElement('input');
      field.type = 'hidden';
      field.name = param.name;
      field.value = param.value;
      form.appendChild(field);
    });
    document.body.appendChild(form);
    form.submit();
  }

  function getLanguageAttr(event) {
    const currLink = event.currentTarget;
    if (!currLink) return;
    if (currLink.classList.contains('disabled') || currLink.getAttribute('data-active') === 'true') {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    geolocatorClearCookie('check_cart');
    // Use Markets locale root_url (more reliable than /localization language POST on preview)
    window.location.href = currLink.href;
  }

  // OK
  function getLinkAttr(event) {
    let currLink = event.currentTarget;
    if(currLink) {
        geolocatorClearCookie('check_cart');
        event.preventDefault();
        let currCountry = currLink.getAttribute('data-country');
        if(currCountry) {
          geolocatorUpdateCookie('geolocator_country',currCountry,false);
          _currCountry = currCountry;
        }
        const countryIsoCode = currCountry || geolocatorGetCookie('geolocator_country');
        if(!countryIsoCode) {
          const fallbackHref = currLink.getAttribute('href') || currLink.getAttribute('data-link') || '/';
          window.location.href = fallbackHref;
          return;
        }
        const languageCode = (typeof geo_country_map !== 'undefined'
          && geo_country_map[countryIsoCode]
          && geo_country_map[countryIsoCode].dl)
          ? geo_country_map[countryIsoCode].dl
          : null;
        const fields = { country_code: countryIsoCode };
        if (languageCode) fields.language_code = languageCode;
        shopifyLocalizationRedirect(fields);
    }
  }

  // OK
  function geolocatorCacheSelectors() {
    geolocatorCache = {
      body: document.body,
      geolocatorWrapper: document.getElementById(geolocatorClassesIds.geolocatorWrapper)
    };
  }

  // OK
  function geolocatorGetCookie(name) {
    /* Method 1
     name = name + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    let cookies = decodedCookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      if (cookie.indexOf(name) == 0) {
        return cookie.substring(name.length, cookie.length);
      }
    } */
    /* MEthod 2
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    */
    const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
  }

/* Geolocator */

/* Footer Copyright */
  window.addEventListener('DOMContentLoaded', footerCopy);

  function footerCopy() {
    if(!_cmejs || !_fceu || !_fcneu || !document.querySelector('.Footer__Copy .copy')) return;
    const country = geolocatorGetCookie('geolocator_country');
    if(!country) return;
    document.querySelector('.Footer__Copy .copy').innerHTML = _cmejs.includes(country) ? _fceu : _fcneu;
  }
/* Footer Copyright */

/* Product Page */
  window.addEventListener('DOMContentLoaded', taxDisclaimerPDP);

  function taxDisclaimerPDP() {
    if(!_cmejs || typeof _txeu === 'undefined' || !_txeu || typeof _txneu === 'undefined' || !_txneu || !document.querySelector('.ProductMeta__TaxNotice')) return;
    const country = geolocatorGetCookie('geolocator_country');
    if(!country) return;
    document.querySelector('.ProductMeta__TaxNotice').textContent = _cmejs.includes(country) ? _txeu : _txneu;
  }
/* Product Page */

/* Shopify Markets - Check Cart */
    //window.addEventListener('DOMContentLoaded', verifycheckCart);
    var _nuc = {};
    // function verifycheckCart() {

    // }
    function checkCart() {
      // debugger;
      console.log('check Cart');
// debugger;
      const nocommerce = checkNoCommerce();
      console.log('is no-commerce:', nocommerce);
      if(nocommerce) return;
// debugger;
      if(!_cart) {
        console.log('----------------- CART 1 -------------------------');
        fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          _cart = data;
          console.log(data);
          console.log('----------------- CART 1 -------------------------');
          console.log(`__cart: ${data}`);
          if(_cart && _cart.items) iterateOverProds(data.items);
        }).catch(function(error) {
          console.error(`Error retreiving cart: ${error}`);
          _cart = null;
        });
        return;
      }
      if(_cart && _cart.items) iterateOverProds(_cart.items);
    }
    function checkNoCommerce() {
      if(!nocommerce_markets) return false;
      let res = false;
      nocommerce_markets.split(',').forEach(_c => {
        __cm[_c].forEach(country => {
          if(country === current_market) res = true;
        });
      });
      if(!res) return false;
      if(!_cart) {
        console.log('----------------- CART 2 -------------------------');
        fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          _cart = data;
          console.log(data);
          console.log('----------------- CART 3 -------------------------');
          console.log(`__cart: ${data}`);
          clearCart();
        }).catch(function(error) {
          console.error(`Error retreiving cart: ${error}`);
          _cart = null;
        });
      } else {
        clearCart();
      }
      return true;
    }
    function clearCart() {
      if(_cart && _cart.items && _cart.items.length > 0) {
        alert(`Siamo spiacenti, non è possibile acquistare in questa country. Il carrello verrà svuotato e la pagina verrà ricaricata automaticamente.`);
        fetch('/cart/clear.js')
        .then(response => response.json())
        .then(data => {
          _cart = data;
          console.log('cleared cart:');
          console.log(data);
          console.log('----------------- CART 3 -------------------------');
          location.reload();
        }).catch(function(error) {
          console.error(`Error retreiving cart: ${error}`);
          _cart = null;
        });
      }
    }
    function iterateOverProds(els) {
      // debugger;
      console.log('iterateOverProds');
      console.log('iterateOverProds',els);
      let _updatedCart = false;
      els.forEach((el, i) => {
        if(!el.properties._prod_tags) {
          _nuc[el.id] = 0;
          _updatedCart = true;
          return;
        }
        if(el.properties._prod_tags.indexOf('__do_not_sell_to:') < 0) {
          _nuc[el.id] = el.quantity;
          return;
        }
        const excluded_country_obj = el.properties._prod_tags.match(/__do_not_sell_to:(.*?),/i);
        if(!excluded_country_obj) return;
        const countries = excluded_country_obj[1].replace(/_/g, ',').replace(/\*/g, '_');
        if(!countries) return;
        countries.split(',').forEach(c => {
          if(__cm[c]) {
            // debugger;
            __cm[c].forEach(_c => {
              // debugger;
              if(_c === current_market) {
                // debugger;
              console.log('_c',_c);
                _nuc[el.id] = 0;
                _updatedCart = true;
              }
              console.log('updateCart',updateCart);
            });
          }
        });
      });
      console.log('_nuc',_nuc);
      // debugger;
      if(!_updatedCart) return;
      // debugger;
      if(_nuc && Object.keys(_nuc).length === 0 && Object.getPrototypeOf(_nuc) === Object.prototype) return;
      // debugger;
      updateCart();
    }
    function updateCart() {
      debugger;
      alert(`Siamo spiacenti, c'è stato un problema con alcuni dei prodotti nel tuo carrello che sono stati rimossi. La pagina verrà ricaricata automaticamente.`);
      const request = {
        method: 'POST',
        headers: new Headers({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ updates: _nuc })
      };
      fetch('/cart/update.js', request)
      .then(response => response.json())
      .then(data => {
        console.log('updated cart');
        location.reload();
      }).catch(function(error) {
        console.error(`Error retreiving cart: ${error}`);
      });
    }


	function setOneItemOnCart(_cart){
		if(_cart.items.length == 1 && _cart.items[0].quantity == 1){
			return;
		}else{
			_cart.items.forEach((el, i) => {
				if(i != _cart.items.length - 1 ){
					_nuc[el.id] = 0;
				} else {
					_nuc[el.id] = 1;
				}
			});
			if(_nuc && Object.keys(_nuc).length === 0 && Object.getPrototypeOf(_nuc) === Object.prototype) return;
			alert(`Sorry, there is a problem: you cannot order more than one item. Some of the creations in your shopping cart will be removed and the page will reload automatically.`);
			const request = {
				method: 'POST',
				headers: new Headers({ 'Content-Type': 'application/json' }),
				body: JSON.stringify({ updates: _nuc })
			};
			fetch('/cart/update.js', request)
				.then(response => response.json())
				.then(data => {
					console.log('updated cart');
					location.reload();
				}).catch(function(error) {
				console.error(`Error retreiving cart: ${error}`);
			});
		}
	}
	function setMaxOneItemPerOrder() {
		const nocommerce = checkNoCommerce();
		if(nocommerce) return;
		fetch('/cart.js')
			.then(response => response.json())
			.then(data => {
				_cart = data;
				setOneItemOnCart(_cart);
			}).catch(function (error) {
			console.error(`Error retreiving cart: ${error}`);
			_cart = null;
		});
	}

	if( geolocatorGetCookie('geolocator_country') == 'CN' ) {
		setMaxOneItemPerOrder();
		document.addEventListener('product:added', setMaxOneItemPerOrder);
		// on qnty changes on cart page
		if( document.querySelector('body.template-cart ') ) {
			console.log('cart-page')
			document.addEventListener('theme:loading:end', setMaxOneItemPerOrder);
		}
	}
/* Shopify Markets - Check Cart */


/* Fix Link Static Pages */
  window.addEventListener('DOMContentLoaded',fixLinkPages);
  function fixLinkPages() {
    if(!document.body.classList.contains('template-page')) return;
    if(document.querySelector('.static-page-main .main-content a')) {
      document.querySelectorAll('.static-page-main .main-content a').forEach(a => {
        if(!update_slug) {
          const _geo_slug = geolocatorGetCookie('geolocator_slug');
          if(_geo_slug !== '/' && a.getAttribute('href').startsWith('/')) a.href = _geo_slug+a.getAttribute('href');
        }
      });
      update_slug = true;
    }
  }
/* Fix Link Static Pages */

/* CUSTOM sticky toolbar on scroll >> */
window.addEventListener('DOMContentLoaded', customStickyEventsToolbar);
/* << CUSTOM sticky toolbar on scroll */

/* Product sticky bar on mobile >> */
window.addEventListener('DOMContentLoaded', initProductStickyBar);

function initProductStickyBar() {
  if (!document.body.classList.contains('template-product')) return;

  const productSection = document.querySelector('[data-section-type="product"]');
  const stickyBar = document.querySelector('.ProductStickyBar');
  const buyButtons = productSection && productSection.querySelector('.ProductForm__BuyButtons');

  if (!productSection || !stickyBar || !buyButtons) return;
  if (productSection.classList.contains('Product--do-not-sell-to')) return;

  const stickyPrice = stickyBar.querySelector('.ProductStickyBar__Price');
  const stickyBtn = stickyBar.querySelector('.ProductStickyBar__AddToCart');
  const stickySoldOut = stickyBar.querySelector('.ProductStickyBar__SoldOut');
  const mainPriceList = productSection.querySelector('.ProductMeta__PriceList');
  const mainBtn = productSection.querySelector('.ProductForm__AddToCart');
  const mainSoldOut = productSection.querySelector('.sold-out-label');

  function syncProductStickyBar() {
    if (mainPriceList && stickyPrice) {
      stickyPrice.innerHTML = mainPriceList.outerHTML;
    }

    const restockBtn = productSection.querySelector('.restock-alerts-notify-button');

    if (restockBtn && restockBtn.offsetParent !== null) {
      if (stickyBtn) {
        stickyBtn.style.display = 'flex';
        stickyBtn.disabled = false;
        stickyBtn.querySelector('span').textContent = restockBtn.textContent.trim();
      }
      if (stickySoldOut) stickySoldOut.style.display = 'none';
      return;
    }

    if (!mainBtn || !stickyBtn) return;

    const isAvailable = mainBtn.dataset.action === 'add-to-cart' && mainBtn.style.display !== 'none';

    if (isAvailable) {
      stickyBtn.style.display = 'flex';
      stickyBtn.disabled = mainBtn.disabled;
      const mainLabel = mainBtn.querySelector('span');
      stickyBtn.querySelector('span').textContent = mainLabel ? mainLabel.textContent.trim() : mainBtn.textContent.trim();
      if (stickySoldOut) stickySoldOut.style.display = 'none';
    } else {
      stickyBtn.style.display = 'none';
      if (stickySoldOut && mainSoldOut) {
        stickySoldOut.textContent = mainSoldOut.textContent.trim();
        stickySoldOut.style.display = stickySoldOut.textContent ? 'block' : 'none';
      }
    }
  }

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      const showBar = !entry.isIntersecting;
      stickyBar.classList.toggle('is-visible', showBar);
      stickyBar.setAttribute('aria-hidden', showBar ? 'false' : 'true');
      document.documentElement.classList.toggle('has-product-sticky-bar', showBar);
    });
  }, { threshold: 0 });

  observer.observe(buyButtons);

  stickyBtn.addEventListener('click', function() {
    const restockBtn = productSection.querySelector('.restock-alerts-notify-button');
    const addToCartBtn = productSection.querySelector('.ProductForm__AddToCart[data-action="add-to-cart"]');

    if (restockBtn && restockBtn.offsetParent !== null) {
      restockBtn.click();
      return;
    }

    if (addToCartBtn) {
      addToCartBtn.click();
    }
  });

  document.addEventListener('variant:changed', syncProductStickyBar);

  const buyButtonsObserver = new MutationObserver(syncProductStickyBar);
  buyButtonsObserver.observe(buyButtons, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'disabled', 'data-action'] });

  syncProductStickyBar();
}
/* << Product sticky bar on mobile */
